import React, { useEffect, useState, forwardRef, useCallback } from 'react';
import axios from '@utils/axiosExt';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import BadgesComponent from '@components/common/Badges';
import CoverageCardViewComponent from '@components/common/CoverageCardView';
import { update_enrollmentdetails, update_rural_hierarchy_details, update_urban_hierarchy_details, update_location_details } from '../../../../constants'
import endpoints from '@config/endpoints';
import HealthFormField from '../../../AppWrapperViewComponent/HealthFacilityOverview/Form/HealthFormField';
import CoverageCardComponent from '@components/common/CoverageCard';
import ABDMVerify from '../../../AppWrapperViewComponent/HealthFacilityOverview/ABDMDetails';
import './HealthFacilityUpdate.css';
import SelectionModal from '../../../../stories/components/SelectionModal/index';
import calculateSimilarity from '@utils/fuzzyLogic';
import Auth from '@utils/auth';
import { approvalStatusUpdate } from '@services/approvalApiServices';
import config from '@config/config';
import { facilityApprovalFormData, facilityApprovalFormState, enrollmentApprovalDetailsFormState, locationApprovalDetailsFormState, hierarchyApprovalDetailsRuralFormState, hierarchyApprovalDetailsUrbanFormState, initialUpdateHealthFacilityFormState, initialUpdateEnrollmentDetailsFormState, initialUpdateHierarchyRuralFormState, initialUpdateHierarchyUrbanFormState, initialUpdateLocationApprovalDetailsFormState, approvalSubmitPayload, updateHierarchyDetailsRuralFormState, updateHierarchyDetailsUrbanFormState, ruralUrbanLabel, ruralUrban } from './HealthFacilityUpdateConstant'
import LocationDetailsEdit from '../../../AppWrapperViewComponent/HealthFacilityOverview/LocationDetailsEdit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { STATUS, errorSuccessMessage, checkUserRole, roleType } from '@constants/approvalConstants';
import { setGeometryMapPoint, setMapManualAddress, setMapLatLong, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setCreateMapPincodeWithHfr, setMapServicesDown } from '@store/actions/facilityGeoMapAction';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import dayjs from 'dayjs';
import FacilityESRIMap from '@components/common/Esrimap/FacilityESRIMap';
import { errorLogger } from '@utils/applicationLogUtils';
import _ from 'lodash';
import { encodeWithKeyAndShift, decodeWithKeyAndShift } from '@utils/base64Utils';
import Button from '@components/common/Button';
import { buttonNames } from '@constants/appConstants';
import { setApprovalPageType } from '@store/actions/approvalActions';
import { approvalConstantData } from '@constants/approvalConstants';
import ApprovalModal from '../approvalModal';
import HFRVerify from '@pages/FacilityManagement/CreateNewFacility/FacilityDetails/HFRVerify';
import { page_type } from '@constants/esriMapConstant';

interface PropsType {
  healthFacility: any
};

const ApprovalHealthFacilityUpdate = (props: PropsType): any => {
  const { healthFacility } = props;
  
  
  const { id } = useParams();
  const navigate = useNavigate();
  const healthFacilityData = healthFacility[0]?.current_data[0]?.facility_info?.facility_details?.[0];
  const effectiveFromDate = healthFacility[0]?.effective_from_date;
  const locationData = healthFacility[0]?.current_data?.[0]?.facility_info?.location_details
  const abdmData = healthFacility[0]?.current_data?.[0]?.facility_info?.abdm_info?.[0];
  const enableArcGISMap = config.enableArcGISMap;

  const dispatch = useDispatch();
  const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);

  const clearMapStore = () => {
    dispatch(setGeometryMapPoint({ mapPointer: '', distFenceGeometry: '' }));
    dispatch(setMapManualAddress(false));
    dispatch(setMapLatLong(null));
    dispatch(setMapManualLatLong(false));
    dispatch(setMapManualLatLongClicked(false));
    dispatch(setMapPincodeFirstTimeEdit(null));
    dispatch(setCreateMapPincodeWithHfr(null))
    dispatch(setMapServicesDown(false));
  }


  useEffect(() => {
    dispatch(setMapPincodeFirstTimeEdit(
      {
        flow: 'edit',
        firstTime: true
      }
    ));
  }, []);

  const [facilityDetailsFormData, setFacilityDetailsFormData] = useState<any>(facilityApprovalFormData);
  const [locationDetailsFormData, setlocationDetailsFormData] = useState<any>(update_location_details);
  const [facilityDetailsFormState, setFacilityDetailsFormState] = useState<any>(facilityApprovalFormState);
  const [enrollmentDetailsFormData, setEnrollmentDetailsFormData] = useState<any>(update_enrollmentdetails);
  const [enrollmentDetailsFormState, setEnrollmentDetailsFormState] = useState<any>(enrollmentApprovalDetailsFormState);
  const [hierarchyDetailsRuralFormData, setHierarchyDetailsRuralFormData] = useState<any>(update_rural_hierarchy_details);
  const [hierarchyDetailsUrbanFormdata, setHierarchyDetailsUrbanFormdata] = useState<any>(update_urban_hierarchy_details);
  const [hierarchyDetailsRuralFormState, setHierarchyDetailsRuralFormState] = useState<any>(hierarchyApprovalDetailsRuralFormState);
  const [hierarchyDetailsUrbanFormState, setHierarchyDetailsUrbanFormState] = useState<any>(hierarchyApprovalDetailsUrbanFormState);
  const [locationDetailsFormState, setLocationDetailsFormState] = useState<any>(locationApprovalDetailsFormState);
  const approvalLayout = useSelector((state: RootState) => state.approvalWorkFlow);
  const [abdmFacilityData, setabdmFacilityData] = useState<any>({});
  const [abdmLocalData, setABDMLocalData] = useState<any>({});
  const [hfrIdCheck, setHfrCheck] = useState<string>('')
  const [effectiveDateChange, setEffectiveDateChange] = useState<boolean>(false);
  const [linkedFacilitiesRural, setLinkedFacilitiesRural] = useState<any>([]);
  const [linkedFacilitiesUrban, setLinkedFacilitiesUrban] = useState<any>([]);
  const [linkedVillageRural, setLinkedVillageRural] = useState<any>([]);
  const [linkedGramPanchayatRural, setLinkedGramPanchayatRural] = useState<any>([]);
  const [linkedWardRural, setLinkedWardRural] = useState<any>([]);
  const [islinkedFacilitiesRuralError, setIslinkedFacilitiesRuralError] = useState(false);
  const [islinkedVillageRuralError, setIslinkedVillageRuralError] = useState(false);
  const [islinkedGramPanchayatRuralError, setIslinkedGramPanchayatRuralError] = useState(false);
  const [islinkedWardRuralError, setIslinkedWardRuralError] = useState(false);
  const [errorMessageCovLinkFacilities, setErrorMessageCovLinkFacilities] = useState<string>('');
  const [errorMessageCovLinkVillages, setErrorMessageCovLinkVillages] = useState<string>('');
  const [errorMessageCovLinkGramPanchayat, setErrorMessageCovLinkGramPanchayat] = useState<string>('');
  
  const encodedUserRoles = localStorage.getItem('userRoleDetails');
  const userRolesDetails = encodedUserRoles ? JSON.parse(decodeWithKeyAndShift(encodedUserRoles)).split(', ') : [];
  const roleData = checkUserRole(userRolesDetails);
  const [errorMessageCovLinkWard, setErrorMessageCovLinkWard] = useState<string>('');
  const [facilityDetailsChange, setFacilityDetailsChange] = useState<boolean>(false);
  const [hierarchyDetailsChange, setHierarchyDetailsChange] = useState<boolean>(false);
  const [stateCode, setStateCode] = useState<number>();
  const [distCode, setDistCode] = useState<number>();
  const [loading, setLoading] = useState<boolean>(true);
  const [isGrampanchayat, setIsGrampanchayat] = useState<boolean>(false);
  const [HBSDSelected, setHBSDSelected] = useState<boolean>(false);
  const [ulbInputText, setUlbInputText] = useState<string>('');
  const [linkedFacilities, setLinkedFacilities] = useState([]);
  const [linkedFacilitiesCount, setLinkedFacilitiesCount] = useState<any>(0);
  const [villages, setVillages] = useState([]);
  const [gramPanchayats, setGramPanchayats] = useState([]);
  const [villagesCount, setVillagesCount] = useState<any>(0);
  const [gramPanchayatCount, setGramPanchayatCount] = useState<any>(0);
  const [wards, setWards] = useState([]);
  const [wardsCount, setWardsCount] = useState<any>(0);
  const [showApprovalModal, setShowApprovalModal] = useState<boolean>(false);
  const [verify, setVerify] = useState<boolean>(false);
  const [clickVerify, setClickVerify] = useState<boolean>(false);
  const [abdmVerify, setABDMVerify] = useState<boolean>(false);
  const [hfrIdError, setHfrIdError] = useState<boolean>(false);
  const [abdmClickVerify, setABDMClickVerify] = useState<boolean>(false);
  const [isSourceTypeAllowedToEdit, setIsSourceTypeAllowedToEdit] = useState<boolean>();
  const [status, setStatus] = useState<string>("");
  const [sourceType, setSourceType] = useState<string>();
  const [ABDMdata, setABDMdata] = useState<any>({});
  const [matchingScore, setMatchingScore] = useState<number>(70);

  useEffect(() => {
    const fetchFacility = async () => {
      try {

        let grampanchayat: boolean = false;
        grampanchayat = locationData?.gram_panchayat?.gram_panchayat_name;
        setIsGrampanchayat(grampanchayat)

        const stripLinkedPrefix = (item: any) =>
          Object.fromEntries(
            Object.entries(item).map(([k, v]) => [k.startsWith('linked_') ? k.replace('linked_', '') : k, v])
          );

        locationData.linked_ward = (locationData?.linked_ward || []).map(stripLinkedPrefix)
        locationData.linked_facility_details = (locationData?.linked_facility_details || []).map(stripLinkedPrefix)
        locationData.linked_village = (locationData?.linked_village || []).map(stripLinkedPrefix)
        locationData.linked_gram_panchayat = (locationData?.linked_gram_panchayat || []).map(stripLinkedPrefix)

        const facilityPayload = {
          "facilityId": id,
          "facilityTypeId": healthFacilityData?.facility_type_id,
          "ruralOrUrbanId": locationData?.urban_rual?.urban_rual_id,
          "adminBodyId": healthFacilityData?.admin_body_id,
          "isMigrated": healthFacilityData?.source_type === "Migration" && healthFacilityData?.is_allowed_edit_due_to_source_type,
          "ownershipId": healthFacilityData?.ownership_id,
        }
        
        const facilityDetailsInitialFetch = await axios.post(`${endpoints.facilityDetailsInitialFetch}`, facilityPayload, Auth.loggedInWithJSON());
        const facilityDetailsInitialFetchData = facilityDetailsInitialFetch?.data?.data;
        setStatus(healthFacilityData?.status_name);
        setStateCode(locationData?.state?.state_code);
        setDistCode(locationData?.district?.district_code);
        setSourceType(healthFacilityData?.source_type);
        setIsSourceTypeAllowedToEdit(healthFacilityData?.is_allowed_edit_due_to_source_type);

        if (healthFacilityData?.source_type === "Migration" && healthFacilityData?.is_allowed_edit_due_to_source_type) {
          const today = new Date();
          setEnrollmentDetailsFormData((facility_enrollmentdetails: { date_of_enrollment: any, effective_from_date: any }) => ({
            ...facility_enrollmentdetails,
            date_of_enrollment: {
              ...facility_enrollmentdetails.date_of_enrollment,
              '#isDisabled': false,
              '#required': true,
              '#maxDate': today.toISOString().split('T')[0],
              '#minDate': '1947-08-14'
            }
          }));
          if (healthFacilityData?.facility_type_id) {
            setFacilityDetailsFormData((create_facilitydetails: { facility_type: any, ownership: any, administrative_body: any, central_govt_dept: any }) => ({
              ...create_facilitydetails,
              facility_type: {
                ...create_facilitydetails.facility_type,
                '#isDisabled': false,
                '#required': true,
              },
              ownership: {
                ...create_facilitydetails.ownership,
                '#isDisabled': false,
                '#required': true,
              },
              administrative_body: {
                ...create_facilitydetails.administrative_body,
                '#isDisabled': false,
                '#required': true,
              },
            }));
            try {
              const facility_OwnershipResponse = facilityDetailsInitialFetchData?.ownershipData
              const facility_ownership_options = facility_OwnershipResponse.map((key: any) => ({
                value: key.ownership,
                label: key.ownership,
                id: key.owenership_id
              }));
              const facility_adminBody = facilityDetailsInitialFetchData?.adminBodyData
              const facility_adminBody_options = facility_adminBody.map((key: any) => ({
                value: key.admin_body,
                label: key.admin_body,
                id: key.admin_body_id
              }));
              setFacilityDetailsFormData((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
                ...create_facilitydetails,
                ownership: {
                  ...create_facilitydetails.ownership,
                  '#options': facility_ownership_options,
                  '#isDisabled': false,
                  '#required': true,
                },
                administrative_body: {
                  ...create_facilitydetails.administrative_body,
                  '#options': facility_adminBody_options,
                  '#isDisabled': false,
                  '#required': facility_adminBody_options.length > 0,
                },
              }));
            }
            catch (error: any) {
              errorLogger(error?.response?.data || error?.response || error)
            }
          }
          else {
            setFacilityDetailsFormData((create_facilitydetails: { facility_type: any, ownership: any, administrative_body: any, central_govt_dept: any }) => ({
              ...create_facilitydetails,
              facility_type: {
                ...create_facilitydetails.facility_type,
                '#isDisabled': false,
                '#required': true,
              },
            }));
          }
        }

        const category_value =  locationData?.category_details?.map((value: any) => value?.category_name);
        const category_code =  locationData?.category_details?.map((value: any) => value?.facility_category_code);
        const category_id =  locationData?.category_details?.map((value: any) => value?.category_id);

        setHfrCheck(healthFacilityData?.hfr_id);
        const facility_categoryResponse = await axios.getWithCache(`${endpoints.getFacilityCatByFacilityTypeIdRuralOrUrban(healthFacilityData?.facility_type_id, locationData?.urban_rual?.urban_rual_id)}`, Auth.loggedIn());
        const facility_category_options = facility_categoryResponse.data.data.map((key: any) => ({
          value: key.facility_category,
          label: key.facility_category,
          id: key.facility_category_id,
          code: key.facility_category_code,
        }));

        setFacilityDetailsFormData((create_facilitydetails: { facility_category: any; ownership: any; }) => ({
          ...create_facilitydetails,
          facility_category: {
            ...create_facilitydetails.facility_category,
            '#options': facility_category_options,
          }
        }));
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          ...initialUpdateHealthFacilityFormState(healthFacilityData, locationData, category_code, category_value, category_id)

        }));

        setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
          ...enrollmentDetailsFormState,
          ...initialUpdateEnrollmentDetailsFormState(healthFacilityData,effectiveFromDate)
        }));

        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          ...initialUpdateHierarchyRuralFormState(locationData)
        }));

        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          ...initialUpdateHierarchyUrbanFormState(locationData)
        }));

        setLocationDetailsFormState((locationDetailsFormState: any) => ({
          ...locationDetailsFormState,
          ...initialUpdateLocationApprovalDetailsFormState(healthFacilityData)

        }));

        try {
          const ruralOrUrban = await axios.getWithCache(`${endpoints.getRuralUrbal}`, Auth.loggedIn());
          const ruralOrUrban_options = ruralOrUrban?.data?.data?.map((key: any) => (
            {
              value: key?.urban_rural_name === ruralUrban.rural ? ruralUrbanLabel.rural : ruralUrbanLabel.urban,
              label: key?.urban_rural_name === ruralUrban.rural ? ruralUrbanLabel.rural : ruralUrbanLabel.urban,
              id: key?.urban_rural_id

            }
          ));

          setFacilityDetailsFormData((create_facilitydetails: { rural_urban: any }) => ({
            ...create_facilitydetails,
            rural_urban: {
              ...create_facilitydetails.rural_urban,
              '#options': ruralOrUrban_options,
            }
          }));

        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error)
        }

        try {
          const facility_typeResponse = facilityDetailsInitialFetchData?.facilityTypeData 

          const facility_type_options = facility_typeResponse.map((key: any) => ({
            value: key.facility_type,
            label: key.facility_type,
            id: key.facility_type_id
          }));

          setFacilityDetailsFormData((create_facilitydetails: { facility_category: any; facility_type: any; ownership: any; }) => ({
            ...create_facilitydetails,
            facility_type: {
              ...create_facilitydetails.facility_type,
              '#options': facility_type_options,
            },
          }));
        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error)
        }

        if (healthFacilityData?.status_name !== 'Inactive') {
          setEnrollmentDetailsFormData((facility_enrollmentdetails: { status: any }) => ({
            ...facility_enrollmentdetails,
            status: {
              ...facility_enrollmentdetails.status,
              '#isDisabled': false,
              '#required': true
            }
          }));
        }
        try {
          const facility_status = await axios.getWithCache(`${endpoints.getFacilityStatus}`, Auth.loggedIn());
          const value = facility_status.data.data && facility_status.data.data.map((v: any) => ({
            value: v.status,
            label: v.status,
            id: v.satus_id,
          }));
          const updatedOptions = value.filter((option: any) => option.value !== 'Inactive');
          setEnrollmentDetailsFormData((facility_enrollmentdetails: { status: any }) => ({
            ...facility_enrollmentdetails,
            status: {
              ...facility_enrollmentdetails.status,
              '#options': updatedOptions,
            }
          }));

        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error)
        }
        const data = {
          "stateId": locationData?.state?.state_id,
          "distId": locationData?.district?.district_id,
          "pacId": locationData?.pc?.pc_id,
          "blockId": locationData?.block?.block_id,
          "ulbId": locationData?.ulb?.ulb_id,
          "isRural": locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.rural,
          "subDistId": locationData?.sub_district?.sub_district_id

        }
        const headerHierarchy: any = Auth.loggedInWithJSON();
        const hierarchyDetailsInitialFetch = await axios.post(`${endpoints.hierarchyDetailsInitialFetch}`, data, headerHierarchy);
        const hierarchyDetailsInitialFetchData = hierarchyDetailsInitialFetch?.data?.data;
        const getUlb = locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.urban && hierarchyDetailsInitialFetchData?.ulbData
        const getDist = hierarchyDetailsInitialFetchData?.distData;
        const getSubDist: any = hierarchyDetailsInitialFetchData?.subDistData;
        const getHealthBlock: any = hierarchyDetailsInitialFetchData?.healthBlockData;
        const subDivision: any = hierarchyDetailsInitialFetchData?.subDivisionData;
        const getBlock: any = hierarchyDetailsInitialFetchData?.blockData;

        setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          district: {
            ...hierarchy_details_urban.district,
            '#options': getDist,
            '#isDisabled': true
          },
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options': locationData?.urban_rural?.urban_rural_name.toLowerCase() === ruralUrban.urban ? getUlb : [],
          },
          sub_district: {
            ...hierarchy_details_urban.sub_district,
            '#options': getSubDist,
            '#required': getSubDist.length > 0 ? true : false
          },
          health_block: {
            ...hierarchy_details_urban.health_block,
            '#options': getHealthBlock,
          },
          sub_division: {
            ...hierarchy_details_urban.sub_division,
            '#options': subDivision,
          }
        }));
        setHierarchyDetailsRuralFormData((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          district: {
            ...hierarchy_details_rural.district,
            '#options': getDist,
            '#isDisabled': true

          },
          sub_district: {
            ...hierarchy_details_rural.sub_district,
            '#options': getSubDist,
            '#required': getSubDist.length > 0 ? true : false
          },
          health_block: {
            ...hierarchy_details_rural.health_block,
            '#options': getHealthBlock,
          },
          sub_division: {
            ...hierarchy_details_rural.sub_division,
            '#options': subDivision,
          },
          block: {
            ...hierarchy_details_rural.block,
            '#options': locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.rural ? getBlock : [],
            '#required': hierarchyDetailsInitialFetchData?.blockData?.length ? true : false,
          },
        }));

        try {
          if (locationData?.ulb?.ulb_id) {
            const getWard = hierarchyDetailsInitialFetchData.wardData
            for (let i = 0; i < getWard.length; i++) {
              getWard[i].ward_name = `${locationData?.ulb?.ulb_name}-${locationData?.ulb?.ulb_code}-${getWard[i].ward_name}-${getWard[i].ward_code}`
            }
            setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: { ward: any }) => ({
              ...hierarchy_details_urban,
              ward: {
                ...hierarchy_details_urban.ward,
                '#options': getWard
              }
            }));
            setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
              ...hierarchyDetailsUrbanFormState,
              ward: {
                ...hierarchyDetailsUrbanFormState.ward,
                value: `${locationData?.ward?.ward_name}-${locationData?.ward?.ward_code}`,
                id: locationData?.ward?.ward_id,
                code: locationData?.ward?.ward_code,
              }
            }))
          }
        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
        }

        if (grampanchayat) {
          setHierarchyDetailsRuralFormData((hierarchy_details_rural: { gram_panchayat: any, village: any }) => ({
            ...hierarchy_details_rural,
            gram_panchayat: {
              ...hierarchy_details_rural.gram_panchayat,
              '#isVisible': true
            },
            village: {
              ...hierarchy_details_rural.village,
              '#isVisible': false
            },
          }))
        }
        else {
          setHierarchyDetailsRuralFormData((hierarchy_details_rural: { gram_panchayat: any, village: any }) => ({
            ...hierarchy_details_rural,
            gram_panchayat: {
              ...hierarchy_details_rural.gram_panchayat,
              '#isVisible': false
            },
            village: {
              ...hierarchy_details_rural.village,
              '#isVisible': true
            },
          }))
        }
        try {
          if (locationData?.block?.block_id) {
            if (grampanchayat) {
              const gramPanchayat = hierarchyDetailsInitialFetchData?.gramPanchayatData;
              const gramPanchayatOptions = gramPanchayat.map((option1: any) => ({
                value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
                label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
                id: option1.gram_panchayat_id,
                code: option1.gram_panchayat_code
              }));
              setHierarchyDetailsRuralFormData((hierarchy_details_rural: { gram_panchayat: any, village: any }) => ({
                ...hierarchy_details_rural,
                gram_panchayat: {
                  ...hierarchy_details_rural.gram_panchayat,
                  '#options': gramPanchayatOptions,
                  '#required': gramPanchayat?.length ? true : false,
                },
              }))
            }
            else {
              const getVilage = hierarchyDetailsInitialFetchData?.villageData[0];
              const villageOptions = getVilage.map((option1: any) => ({
                value: `${option1.village_name}-${option1.village_code}`,
                label: `${option1.village_name}-${option1.village_code}`,
                id: option1.village_id,
                code: option1.village_code
              }));
              setHierarchyDetailsRuralFormData((hierarchy_details_rural: { village: any }) => ({
                ...hierarchy_details_rural,
                village: {
                  ...hierarchy_details_rural.village,
                  '#options': villageOptions,
                  '#required': getVilage?.length ? true : false
                },
              }))
            }
          }
        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
        }

        if (locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.rural) {
          try {
            const getPac = hierarchyDetailsInitialFetchData?.pacData;
            setHierarchyDetailsRuralFormData((hierarchy_details_rural: { parlimentary: any }) => ({
              ...hierarchy_details_rural,
              parlimentary: {
                ...hierarchy_details_rural.parlimentary,
                '#options': getPac
              }
            }));
            setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
              ...hierarchyDetailsRuralFormState,
              parlimentary: {
                ...hierarchyDetailsRuralFormState.parlimentary,
                value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.rural && locationData?.pc?.pc_name ? locationData?.pc?.pc_name : '',
                id: locationData?.pc?.pc_id,
                code: locationData?.pc?.pc_code
              },
            }))
          }
          catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
          }
        }

        if (locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.urban) {
          try {
            if (locationData?.ward?.ward_id) {
              const getPac = hierarchyDetailsInitialFetchData?.pacData;
              setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: { parlimentary: any }) => ({
                ...hierarchy_details_urban,
                parlimentary: {
                  ...hierarchy_details_urban.parlimentary,
                  '#options': getPac
                }
              }));
              setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
                ...hierarchyDetailsUrbanFormState,
                parlimentary: {
                  ...hierarchyDetailsUrbanFormState.parlimentary,
                  value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.urban && locationData?.pc?.pc_name ? locationData?.pc?.pc_name : '',
                  id: locationData?.pc?.pc_id,
                  code: locationData?.pc?.pc_code
                },
              }))
            }
          }
          catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
          }
        }

        try {
          if (locationData?.pc?.pc_id) {
            const getLac = hierarchyDetailsInitialFetchData?.lacData;
            if (locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.urban) {
              setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: { lac: any }) => ({
                ...hierarchy_details_urban,
                lac: {
                  ...hierarchy_details_urban.lac,
                  '#options': getLac,
                }
              }));
              setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
                ...hierarchyDetailsUrbanFormState,
                lac: {
                  ...hierarchyDetailsUrbanFormState.lac,
                  value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.urban && locationData?.lac?.lac_name ? locationData?.lac?.lac_name : '',
                  id: locationData?.lac?.lac_id,
                  code: locationData?.lac?.lac_code
                }
              }))
            }
            else {
              setHierarchyDetailsRuralFormData((hierarchy_details_rural: { lac: any }) => ({
                ...hierarchy_details_rural,
                lac: {
                  ...hierarchy_details_rural.lac,
                  '#options': getLac,
                }
              }));
              setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
                ...hierarchyDetailsRuralFormState,
                lac: {
                  ...hierarchyDetailsRuralFormState.lac,
                  value: locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.rural && locationData?.lac?.lac_name ? locationData?.lac?.lac_name : '',
                  id: locationData?.lac?.lac_id,
                  code: locationData?.lac?.lac_code
                }
              }))
            }
          }
        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
        }

        if (grampanchayat) {
          setLinkedGramPanchayatRural(locationData?.linked_gram_panchayat);
          if (locationData?.health_block?.health_block_id || locationData?.sub_division?.sub_division_id) {
            getSelectionGramPanchayats("", "", locationData?.health_block?.health_block_id, locationData?.sub_division?.sub_division_id)
          }
          else {
            getSelectionGramPanchayats(locationData?.block?.block_id, locationData?.sub_district?.sub_district_id, "", "")
          }
        }
        else {
          setLinkedVillageRural(locationData?.linked_village);
          if (locationData?.health_block?.health_block_id || locationData?.sub_division?.sub_division_id) {
            getSelectionVillages("", "", locationData?.health_block?.health_block_id, locationData?.sub_division?.sub_division_id)
          }
          else {
            getSelectionVillages(locationData?.block?.block_id, locationData?.sub_district?.sub_district_id, "", "")
          }
        }

        setLinkedWardRural(locationData?.linked_ward);
        if (locationData?.health_block?.health_block_id || locationData?.sub_division?.sub_division_id) {
          getSelectionWards("", locationData?.health_block?.health_block_id, locationData?.sub_division?.sub_division_id)
        }
        else {
          getSelectionWards(locationData?.ulb?.ulb_id, "", "")
        }

        if (locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.rural && healthFacilityData?.facility_type_id) {
          setLinkedFacilitiesRural(locationData?.linked_facility_details);

          getSelectionFacilitiesRural(locationData?.block?.block_id, healthFacilityData?.facility_type_id);
          let linkedFaciltiesOptionsObject: any = {};
          const options2: string[] = locationData?.linked_facility_details;
          const linkedFaciltiesOptions: any = [];
          options2.map((option1: any) => {
            linkedFaciltiesOptions.push(option1?.facility_name)
          })
          linkedFaciltiesOptionsObject = linkedFaciltiesOptions.reduce((acc: any, current: any) => {
            if (!acc[current]) {
              acc[current] = current;
            }
            return acc;
          }, {});
        }
        if (locationData?.urban_rual?.urban_rural_name.toLowerCase() === ruralUrban.urban && healthFacilityData?.facility_type_id) {
          setLinkedFacilitiesUrban(locationData?.linked_facility_details);
          getSelectionFacilitiesUrban(locationData?.ulb?.ulb_id, healthFacilityData?.facility_type_id);
        }
        Promise.resolve();
      }
      catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
      }
    }
    fetchFacility().then(() => {
      setLoading(false);
      

      if (approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received && roleData == roleType.only_approver) {
        
        setFacilityDetailsFormData((prevState: any) => ({
          ...prevState,
          hfr_id: {
            ...prevState.hfr_id,
            '#isDisabled': true,
          },
          facility_name: {
            ...prevState.facility_name,
            '#isDisabled': true,
          },
          facility_type: {
            ...prevState.facility_type,
            '#isDisabled': true,
          },
          facility_category: {
            ...prevState.facility_category,
            '#isDisabled': true,
          },
          ownership: {
            ...prevState.ownership,
            '#isDisabled': true,
          },
          administrative_body: {
            ...prevState.administrative_body,
            '#isDisabled': true,
          },
          central_govt_dept: {
            ...prevState.central_govt_dept,
            '#isDisabled': true,
          },
          rural_urban: {
            ...prevState.rural_urban,
            '#isDisabled': true,
          },
        }));
        
        setEnrollmentDetailsFormData((prevState: any) => ({
          ...prevState,
          date_of_enrollment: {
            ...prevState.date_of_enrollment,
            '#isDisabled': true,
          },
          effective_from_date: {
            ...prevState.effective_from_date,
            '#isDisabled': true,
          },
          status: {
            ...prevState.status,
            '#isDisabled': true,
          },
          sanctionedbed_count: {
            ...prevState.sanctionedbed_count,
            '#isDisabled': true,
          },
          functionalbed_count: {
            ...prevState.functionalbed_count,
            '#isDisabled': true,
          },
        }));
        
        setHierarchyDetailsRuralFormData((prevState: any) => ({
          ...prevState,
          state: {
            ...prevState.state,
            '#isDisabled': true,
          },
          district: {
            ...prevState.district,
            '#isDisabled': true,
          },
          sub_district: {
            ...prevState.sub_district,
            '#isDisabled': true,
          },
          block: {
            ...prevState.block,
            '#isDisabled': true,
          },
          health_block: {
            ...prevState.health_block,
            '#isDisabled': true,
          },
          sub_division: {
            ...prevState.sub_division,
            '#isDisabled': true,
          },
          village: {
            ...prevState.village,
            '#isDisabled': true,
          },
          gram_panchayat: {
            ...prevState.gram_panchayat,
            '#isDisabled': true,
          },
          parlimentary: {
            ...prevState.parlimentary,
            '#isDisabled': true,
          },
          lac: {
            ...prevState.lac,
            '#isDisabled': true,
          },
        }));
        
        setHierarchyDetailsUrbanFormdata((prevState: any) => ({
          ...prevState,
          state: {
            ...prevState.state,
            '#isDisabled': true,
          },
          district: {
            ...prevState.district,
            '#isDisabled': true,
          },
          sub_district: {
            ...prevState.sub_district,
            '#isDisabled': true,
          },
          ulb: {
            ...prevState.ulb,
            '#isDisabled': true,
          },
          ward: {
            ...prevState.ward,
            '#isDisabled': true,
          },
          village: {
            ...prevState.village,
            '#isDisabled': true,
          },
          gram_panchayat: {
            ...prevState.gram_panchayat,
            '#isDisabled': true,
          },
          parlimentary: {
            ...prevState.parlimentary,
            '#isDisabled': true,
          },
          lac: {
            ...prevState.lac,
            '#isDisabled': true,
          },
        }));
        
        setlocationDetailsFormData((prevState: any) => ({
          ...prevState,
          pincode: {
            ...prevState.pincode,
            '#isDisabled': true,
          },
          lattitude: {
            ...prevState.lattitude,
            '#isDisabled': true,
          },
          longitude: {
            ...prevState.longitude,
            '#isDisabled': true,
          },
          address: {
            ...prevState.address,
            '#isDisabled': true,
          },
        }));
      }
    });
    if(healthFacilityData?.source_type === "Migration") {
          setEnrollmentDetailsFormData((facility_enrollmentdetails: { date_of_enrollment: any, effective_from_date: any }) => ({
            ...facility_enrollmentdetails,
            effective_from_date: {
              ...facility_enrollmentdetails.effective_from_date,
              '#isDisabled': false,
              '#required': true,
              '#maxDate': new Date().toISOString().split('T')[0],
              '#minDate': dayjs().startOf('month')
            }
          }))
        }
  }, []);


  useEffect(() => {

    if (sourceType === "Migration" && isSourceTypeAllowedToEdit && facilityDetailsChange) {
      const fetchFacilityType = async () => {
        try {
          const facility_typeResponse = await axios.get(endpoints.getFacilityType, Auth.loggedIn());
          const facility_type_options = facility_typeResponse.data.data.map((key: any) => ({
            value: key.facility_type,
            label: key.facility_type,
            id: key.facility_type_id
          }));

          setFacilityDetailsFormData((create_facilitydetails: { facility_category: any; facility_type: any; ownership: any; }) => ({
            ...create_facilitydetails,
            facility_type: {
              ...create_facilitydetails.facility_type,
              '#options': facility_type_options,
            },

          }))
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            ownership: {
              ...facilityDetailsFormState.ownership,
              value: '',
              id: '',
              code: '',
            },
            administrative_body: {
              ...facilityDetailsFormState.administrative_body,
              value: '',
              id: '',
              code: '',
            },
            central_govt_dept: {
              ...facilityDetailsFormState.central_govt_dept,
              value: '',
              id: '',
              code: '',
            },
            facility_category: {
              ...facilityDetailsFormState.facility_category,
              value: [],
              id: [],
              code: [],
            },
          }));
        }
        catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
        }
      };
      fetchFacilityType();
      fetchOwnershipAdminbody(facilityDetailsFormState?.facility_type?.id);

    }
  }, [facilityDetailsFormState?.facility_type?.id]);

  const fetchOwnershipAdminbody = async (facilityTypeId: string) => {
    if (facilityTypeId) {
      try {
        const facility_OwnershipResponse = await axios.get(`${endpoints.getOwnerByFacilityTypeId(facilityTypeId)}`, Auth.loggedIn());
        const facility_ownership_options = facility_OwnershipResponse.data.data.map((key: any) => ({
          value: key.ownership,
          label: key.ownership,
          id: key.owenership_id
        }));
        setFacilityDetailsFormData((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
          ...create_facilitydetails,
          ownership: {
            ...create_facilitydetails.ownership,
            '#options': facility_ownership_options,
            '#isDisabled': false,
            '#required': true,
          },
          administrative_body: {
            ...create_facilitydetails.administrative_body,
            '#options': []
          },
        }));
      }
      catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
      }
    } else {
      setFacilityDetailsFormData((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
        ...create_facilitydetails,
        ownership: {
          ...create_facilitydetails.ownership,
          '#options': []
        },
        administrative_body: {
          ...create_facilitydetails.administrative_body,
          '#options': []
        },
      }));
    }
  };

  useEffect(() => {
    const fetchAdminbody = async () => {
      if (facilityDetailsFormState?.ownership?.id && facilityDetailsFormState?.facility_type?.id) {
        try {
          const facility_adminBody = await axios.get(`${endpoints.getAdminBody(facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.ownership?.id)}`, Auth.loggedIn());
          const facility_adminBody_options = facility_adminBody.data.data.map((key: any) => ({
            value: key.admin_body,
            label: key.admin_body,
            id: key.admin_body_id
          }));

          setFacilityDetailsFormData((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
            ...create_facilitydetails,
            administrative_body: {
              ...create_facilitydetails.administrative_body,
              '#options': facility_adminBody_options,
              '#isDisabled': false,
              '#required': facility_adminBody_options?.length > 0,
            },
          }));

          if (facility_adminBody_options?.length === 1) {
            if (sourceType === "Migration" && isSourceTypeAllowedToEdit && facilityDetailsChange) {
              const selectedAdminBody = facility_adminBody_options[0];
              setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                ...facilityDetailsFormState,
                administrative_body: {
                  ...facilityDetailsFormState.administrative_body,
                  value: selectedAdminBody.value,
                  id: selectedAdminBody.id,
                },
              }));
            }
          }
          else {
            if (facilityDetailsChange) {
              setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                ...facilityDetailsFormState,
                administrative_body: {
                  ...facilityDetailsFormState.administrative_body,
                  value: '',
                  id: '',
                  code: '',
                },
              }));
            }
          }
        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
        }
      }
      else {
        setFacilityDetailsFormData((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
          ...create_facilitydetails,
          administrative_body: {
            ...create_facilitydetails.administrative_body,
            '#options': [],
          },
        }));
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            administrative_body: {
              ...facilityDetailsFormState.administrative_body,
              value: '',
              id: '',
              code: '',
            }
          }));
      }
    };

    fetchAdminbody();

  }, [facilityDetailsFormState?.ownership?.id])


  useEffect(() => {

    if (sourceType === "Migration" && isSourceTypeAllowedToEdit && facilityDetailsChange) {
      let facility_centralGovtDept;
      if (facilityDetailsFormState.administrative_body.id && facilityDetailsFormState.facility_type.id) {
        const fetchCentalGovtDept = async () => {
          try {
            facility_centralGovtDept = await axios.getWithCache(`${endpoints.getCentralGovtDeptByFacTypeIdAdminBodyId}/${facilityDetailsFormState.facility_type.id}/${facilityDetailsFormState.administrative_body.id}`, Auth.loggedIn());
            const facility_centralGovtDept_options = facility_centralGovtDept.data.data.map((key: any) => ({
              value: key.central_govt_dept_name,
              label: key.central_govt_dept_name,
              id: key.central_govt_dept_id
            }));
            if (facilityDetailsFormState.facility_type.value !== 'Defence Hospital' || facilityDetailsFormState.facility_type.value !== 'ESI Hospital' || facilityDetailsFormState.facility_type.value !== 'Railway Hospital') {
              if (facilityDetailsFormState.administrative_body.value !== "Central Government") {
                setFacilityDetailsFormData((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': [],
                    '#isDisabled': true,
                    '#required': false
                  }
                }))
              }
              else {
                if (facility_centralGovtDept.data.data.length !== 0) {
                  setFacilityDetailsFormData((create_facilitydetails: { central_govt_dept: any }) => ({
                    ...create_facilitydetails,
                    central_govt_dept: {
                      ...create_facilitydetails.central_govt_dept,
                      '#options': facility_centralGovtDept_options,
                      '#isDisabled': false,
                      '#required': true,
                    }
                  }))
                }
                else {
                  setFacilityDetailsFormData((create_facilitydetails: { central_govt_dept: any }) => ({
                    ...create_facilitydetails,
                    central_govt_dept: {
                      ...create_facilitydetails.central_govt_dept,
                      '#options': facility_centralGovtDept_options,
                      '#isDisabled': false,
                      '#required': false,
                    }
                  }))
                }
              }
            }
            else {
              if (facility_centralGovtDept.data.data.length !== 0) {
                setFacilityDetailsFormData((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': facility_centralGovtDept_options,
                    '#isDisabled': false,
                    '#required': true,
                  }
                }))
              }
              else {
                setFacilityDetailsFormData((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': facility_centralGovtDept_options,
                    '#isDisabled': false,
                    '#required': false,
                  }
                }))
              }
            }
          }
          catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
          }
        }
        fetchCentalGovtDept();
      }
      else {
        setFacilityDetailsFormData((create_facilitydetails: { central_govt_dept: any }) => ({
          ...create_facilitydetails,
          central_govt_dept: {
            ...create_facilitydetails.central_govt_dept,
            '#options': [],
            '#isDisabled': true,
            '#required': false
          }
        }))
      }
    }
  }, [facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.administrative_body?.value]);

  useEffect(() => {
    const effectiveFromDate = async () => {
      try {
        const getEntrollmentDate = enrollmentDetailsFormState.date_of_enrollment.value;
        if (sourceType === "Migration" && isSourceTypeAllowedToEdit && effectiveDateChange) {
          const today = new Date();
          const maxDate = today.toISOString().split('T')[0];
          const oneYearAgo = new Date();
          oneYearAgo.setDate(today.getDate() - 365);
          const oneYearAgoDate = oneYearAgo.toISOString().split('T')[0];
          if (dayjs(getEntrollmentDate).format('YYYY-MM-DD') >= oneYearAgoDate && dayjs(getEntrollmentDate).format('YYYY-MM-DD') <= maxDate) {
            setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
              ...enrollmentDetailsFormState,
              effective_from_date: {
                ...enrollmentDetailsFormState.effective_from_date,
                value: getEntrollmentDate,
              }
            }))
          } else {
            setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
              ...enrollmentDetailsFormState,
              effective_from_date: {
                ...enrollmentDetailsFormState.effective_from_date,
                isDisable: false,
                value: '',
              }
            }))
          }
        }
      }
      catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
      }
    }
    effectiveFromDate();

  }
    , [enrollmentDetailsFormState.date_of_enrollment.value]);



  useEffect(() => {
    if (hierarchyDetailsChange) {
      hierarchyDetailsUrbanFormState?.ulb?.id && getWardList(hierarchyDetailsUrbanFormState?.ulb?.id, hierarchyDetailsUrbanFormState?.ulb?.code, hierarchyDetailsUrbanFormState?.ulb?.value);
      setLinkedFacilitiesUrban([]);
      getSelectionFacilitiesUrban(hierarchyDetailsUrbanFormState.ulb.id, facilityDetailsFormState.facility_type.id);
      setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
        ...hierarchyDetailsUrbanFormState,
        ward: {
          ...hierarchyDetailsUrbanFormState.ward,
          value: '',
          id: '',
          code: '',
        },
      }));
      if (!hierarchyDetailsUrbanFormState.ulb.id) {
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
        setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          ward: {
            ...hierarchy_details_urban.ward,
            '#options': [],
          },
        }));
      }
    }
  }, [hierarchyDetailsUrbanFormState.ulb.id]);

  useEffect(() => {
    if (facilityDetailsFormState?.rural_urban?.value?.toLowerCase() === ruralUrban.urban && hierarchyDetailsChange) {
      if (!hierarchyDetailsUrbanFormState?.ulb?.id && !hierarchyDetailsUrbanFormState?.health_block?.id && !hierarchyDetailsUrbanFormState?.sub_division?.id) {
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);
        setWards([]);
        setWardsCount(0);
      }
      const healthBlockId = hierarchyDetailsUrbanFormState?.health_block?.id;
      const subDivisionId = hierarchyDetailsUrbanFormState?.sub_division?.id;
      if (!healthBlockId && !subDivisionId) {
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);
        setWards([]);
        setWardsCount(0);
        getSelectionWards(hierarchyDetailsUrbanFormState?.ulb?.id, "", "");
      }
    }
  }, [hierarchyDetailsUrbanFormState?.ulb?.id])

  useEffect(() => {
    if (hierarchyDetailsChange) {
      const healthBlockId = facilityDetailsFormState?.rural_urban?.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormState?.health_block?.id : hierarchyDetailsUrbanFormState?.health_block?.id;
      const subDivisionId = facilityDetailsFormState?.rural_urban?.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormState?.sub_division?.id : hierarchyDetailsUrbanFormState?.sub_division?.id;
      setVillages([]);
      setVillagesCount(0);
      setLinkedVillageRural([]);
      setGramPanchayatCount(0);
      setGramPanchayats([]);
      setLinkedGramPanchayatRural([]);
      setLinkedWardRural([]);
      setWards([]);
      setWardsCount(0);
      if (!healthBlockId && !subDivisionId) {
        if (facilityDetailsFormState?.rural_urban?.value === ruralUrbanLabel.rural) {
          isGrampanchayat ? getSelectionGramPanchayats(hierarchyDetailsRuralFormState?.block?.id, hierarchyDetailsRuralFormState.sub_district.id, "", "") : getSelectionVillages(hierarchyDetailsRuralFormState?.block?.id, hierarchyDetailsRuralFormState.sub_district.id, "", "");
        }
        else if (facilityDetailsFormState?.rural_urban?.value === ruralUrbanLabel.urban) {
          getSelectionWards(hierarchyDetailsUrbanFormState?.ulb?.id, "", "");
        }
      }
      else {
        getSelectionWards("", healthBlockId, subDivisionId);
        isGrampanchayat ? getSelectionGramPanchayats("", "", healthBlockId, subDivisionId) : getSelectionVillages("", "", healthBlockId, subDivisionId);
      }
    }
  }, [hierarchyDetailsRuralFormState?.health_block?.id, hierarchyDetailsRuralFormState?.sub_division?.id, hierarchyDetailsUrbanFormState?.health_block?.id, hierarchyDetailsUrbanFormState?.sub_division?.id])

  useEffect(() => {
    if (hierarchyDetailsChange) {
      getSubDistHBlockSubDivisionRural(hierarchyDetailsRuralFormState.district.id)
    }
  }, [hierarchyDetailsRuralFormState.district.id])

  useEffect(() => {
    if (hierarchyDetailsChange) {
      getSubDistHBlockSubDivisionRural(hierarchyDetailsUrbanFormState.district.id)
    }
  }, [hierarchyDetailsUrbanFormState.district.id])

  useEffect(() => {
    if (hierarchyDetailsUrbanFormState?.state?.id && ulbInputText?.length >= 3) {
      getUlb(hierarchyDetailsUrbanFormState?.state?.id, ulbInputText)
    }
    if (ulbInputText?.length === 0) {
      setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': [],
        },
      }));
    }
  }, [ulbInputText])

  const getUlb = async (stateId: any, ulbInputText: string) => {
    try {
      const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(stateId, ulbInputText)}`, Auth.loggedIn());
      const getUlbOptions = getUlbwithsearch?.data.data
      setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': getUlbOptions,
        },
      }));
      setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
        ...hierarchyDetailsUrbanFormState,
        ulb: {
          ...hierarchyDetailsUrbanFormState.ulb,
          value: '',
          id: '',
          code: ''
        },
        ward: {
          ...hierarchyDetailsUrbanFormState.ward,
          value: '',
          id: '',
          code: ''
        },
      }));
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }
  const getBlock = async (distId: any) => {
    try {
      const getBlockRes = await axios.getWithCache(`${endpoints.getBlock(distId)}`, Auth.loggedIn());
      const getBlockOptions = getBlockRes?.data.data;
      setHierarchyDetailsRuralFormData((hierarchy_details_rural: any) => ({
        ...hierarchy_details_rural,
        block: {
          ...hierarchy_details_rural.block,
          '#options': getBlockOptions,
        },
      }));
      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        block: {
          ...hierarchyDetailsRuralFormState.block,
          value: '',
          id: '',
          code: ''
        },
        village: {
          ...hierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code: ''
        },
        gram_panchayat: {
          ...hierarchyDetailsRuralFormState.gram_panchayat,
          value: '',
          id: '',
          code: ''
        },
      }));
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }
  const resetVillageGramPanchayat = () => {
    setHierarchyDetailsRuralFormData((role_details: any) => ({
      ...role_details,
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
      village: {
        ...role_details.village,
        '#options': [],
      },
    }))
    setHierarchyDetailsRuralFormState((roleFormState: any) => ({
      ...roleFormState,
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
        code: ''
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
        code: ''
      },
    }))
    setVillages([]);
    setVillagesCount(0);
    setLinkedVillageRural([]);
    setGramPanchayatCount(0);
    setGramPanchayats([]);
    setLinkedGramPanchayatRural([]);
  }
  useEffect(() => {
    if (facilityDetailsChange) {
      getCatgory(facilityDetailsFormState.facility_type.id, facilityDetailsFormState.rural_urban.id);
      if (facilityDetailsFormState.rural_urban.value?.toLowerCase() !== locationData.urban_rual?.urban_rural_name) {
        if (facilityDetailsFormState.rural_urban.value?.toLowerCase() === ruralUrban.urban) {
          getUlb(locationData.state?.state_id, ulbInputText);
        }
        if (facilityDetailsFormState.rural_urban.value?.toLowerCase() === ruralUrban.rural) {
          getBlock(locationData.district?.district_id);
        }
      }
    }
  }, [facilityDetailsFormState.facility_type.id, facilityDetailsFormState.rural_urban.id])

  useEffect(() => {
    if (facilityDetailsFormState.rural_urban.value?.toLowerCase() === ruralUrban.urban) {
      if (!hierarchyDetailsUrbanFormState?.ulb?.id) {
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
      }
    }
    if (facilityDetailsFormState.rural_urban.value?.toLowerCase() === ruralUrban.rural) {
      if (!hierarchyDetailsRuralFormState?.block?.id) {
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
      }
    }
  }, [facilityDetailsFormState.rural_urban.id])

  useEffect(() => {
    if (hierarchyDetailsChange) {
      getPAC(hierarchyDetailsUrbanFormState.state.id);
    }
  }, [hierarchyDetailsUrbanFormState.state.id]);

  useEffect(() => {
    if (hierarchyDetailsChange) {
      getLAC(hierarchyDetailsUrbanFormState.parlimentary.id);
    }
  }, [hierarchyDetailsUrbanFormState.parlimentary.id, hierarchyDetailsUrbanFormState.parlimentary.value]);
  useEffect(() => {
    if (hierarchyDetailsChange) {
      getLAC(hierarchyDetailsRuralFormState.parlimentary.id);
    }
  }, [hierarchyDetailsRuralFormState.parlimentary.id, hierarchyDetailsRuralFormState.parlimentary.value]);

  useEffect(() => {
    if (hierarchyDetailsChange) {
      if (hierarchyDetailsRuralFormState.block?.id && (hierarchyDetailsRuralFormData?.sub_district['#required'] == true ? hierarchyDetailsRuralFormState.sub_district.id : true)) {
        isGrampanchayat ? getGramPanchayat(hierarchyDetailsRuralFormState.block?.id) : getVillage(hierarchyDetailsRuralFormState.block?.id);
      }
      resetVillageGramPanchayat();
      setLinkedFacilitiesRural([]);
      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        village: {
          ...hierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code: '',
        }
      }));
      if (!hierarchyDetailsRuralFormState?.block?.id) {
        setLinkedFacilities([]);
        setLinkedFacilitiesCount(0);
        setHierarchyDetailsRuralFormData((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          village: {
            ...hierarchy_details_rural.village,
            '#options': [],
          },

        }));
      }
    }
  }, [hierarchyDetailsRuralFormState.block.id, hierarchyDetailsRuralFormState.sub_district.id]);

  useEffect(() => {
    if (facilityDetailsFormState?.rural_urban?.value?.toLowerCase() === ruralUrban.rural && hierarchyDetailsChange) {
      if (!hierarchyDetailsRuralFormState?.block?.id && !hierarchyDetailsRuralFormState?.health_block?.id && !hierarchyDetailsRuralFormState?.sub_division?.id) {
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);
        setWards([]);
        setWardsCount(0);
      }
      const healthBlockId = hierarchyDetailsRuralFormState?.health_block?.id;
      const subDivisionId = hierarchyDetailsRuralFormState?.sub_division?.id;
      if (!healthBlockId && !subDivisionId) {
        setVillages([]);
        setVillagesCount(0);
        setLinkedVillageRural([]);
        setGramPanchayatCount(0);
        setGramPanchayats([]);
        setLinkedGramPanchayatRural([]);
        setLinkedWardRural([]);
        setWards([]);
        setWardsCount(0);
        isGrampanchayat ? getSelectionGramPanchayats(hierarchyDetailsRuralFormState?.block?.id, hierarchyDetailsRuralFormState.sub_district.id, "", "") : getSelectionVillages(hierarchyDetailsRuralFormState?.block?.id, hierarchyDetailsRuralFormState.sub_district.id, "", "");
      }
    }
  }, [hierarchyDetailsRuralFormState?.block?.id])

  useEffect(() => {
    if (enrollmentDetailsFormState.sanctionedbed_count.value === null || enrollmentDetailsFormState.sanctionedbed_count.value === '0' ||
      enrollmentDetailsFormState.sanctionedbed_count.value === ''
    ) {
      setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
        ...enrollmentDetailsFormState,
        functionalbed_count: {
          ...enrollmentDetailsFormState.functionalbed_count,
          value: ''
        }
      }));
      setEnrollmentDetailsFormData((facility_enrollmentdetails: { functionalbed_count: any }) => ({
        ...facility_enrollmentdetails,
        functionalbed_count: {
          ...facility_enrollmentdetails.functionalbed_count,
          '#isDisabled': true

        }
      }));
    }
    else {
      setEnrollmentDetailsFormData((facility_enrollmentdetails: { functionalbed_count: any }) => ({
        ...facility_enrollmentdetails,
        functionalbed_count: {
          ...facility_enrollmentdetails.functionalbed_count,
          '#isDisabled': false

        }
      }));
    }

  }, [enrollmentDetailsFormState.sanctionedbed_count.value])

  useEffect(() => {
    if (hierarchyDetailsChange) {
      hierarchyDetailsRuralFormState.state.id && getPacByState(hierarchyDetailsRuralFormState.state.id);
    }
  }, [hierarchyDetailsRuralFormState.state.id]);

  const getSubDistHBlockSubDivisionRural = async (districtId: any) => {
    try {
      if (districtId) {
        const getSubDist = await axios.getWithCache(`${endpoints.getSubDistricts(districtId)}`, Auth.loggedIn());
        const getHealthBlock = await axios.getWithCache(`${endpoints.getHealthBlock(districtId)}`, Auth.loggedIn());
        const subDivision = await axios.getWithCache(`${endpoints.getSubDivision(districtId)}`, Auth.loggedIn());
        const getBlock = await axios.getWithCache(`${endpoints.getBlock(districtId)}`, Auth.loggedIn());

        setHierarchyDetailsRuralFormData((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          sub_district: {
            ...hierarchy_details_rural.sub_district,
            '#options': getSubDist.data.data,
          },
          health_block: {
            ...hierarchy_details_rural.health_block,
            '#options': getHealthBlock.data.data,
          },
          sub_division: {
            ...hierarchy_details_rural.sub_division,
            '#options': subDivision.data.data,
          },
          block: {
            ...hierarchy_details_rural.block,
            '#options': getBlock.data.data,
            '#required': getBlock?.data?.data?.length ? true : false,
          },
          village: {
            ...hierarchy_details_rural.village,
            '#options': [],
          },
          gram_panchayat: {
            ...hierarchy_details_rural.gram_panchayat,
            '#options': [],
          },
        }));
        setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          sub_district: {
            ...hierarchy_details_urban.sub_district,
            '#options': getSubDist.data.data,
          },
          health_block: {
            ...hierarchy_details_urban.health_block,
            '#options': getHealthBlock.data.data,
          },
          sub_division: {
            ...hierarchy_details_urban.sub_division,
            '#options': subDivision.data.data,
          }
        }));

        setHierarchyDetailsRuralFormState((HierarchyDetailsRuralFormState: any) => ({
          ...HierarchyDetailsRuralFormState,
          ...updateHierarchyDetailsRuralFormState(HierarchyDetailsRuralFormState)
        }))
        setHierarchyDetailsUrbanFormState((HierarchyDetailsRuralFormState: any) => ({
          ...HierarchyDetailsRuralFormState,
          ...updateHierarchyDetailsUrbanFormState(HierarchyDetailsRuralFormState)
        }))
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getVillage = async (blockId: any) => {
    try {
      if (blockId) {
        const postData = {
          p_state_id: locationData.state?.state_id,
          p_dist_id: locationData.district?.district_id,
          p_sub_dist_ids: hierarchyDetailsRuralFormState?.sub_district?.id ? [hierarchyDetailsRuralFormState.sub_district?.id] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }

        const getVillage = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        const villageOptions = getVillage?.data.data.map((option1: any) => ({
          value: `${option1.village_name}-${option1.village_code}`,
          label: `${option1.village_name}-${option1.village_code}`,
          id: option1.village_id,
          code: option1.village_code
        }));
        setHierarchyDetailsRuralFormData((hierarchy_details_rural: { parlimentary: any; lac: any; village: any }) => ({
          ...hierarchy_details_rural,
          village: {
            ...hierarchy_details_rural.village,
            '#options': villageOptions,
            '#required': villageOptions?.length ? true : false,
          },
        }))
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          village: {
            ...hierarchyDetailsRuralFormState.village,
            value: '',
            id: '',
            code: ''
          },
        }))
        const villagesCoveredOptions: any = [];
        getVillage?.data?.data?.map((e: any) => {
          villagesCoveredOptions.push(e?.village_name)
        })
        setVillagesCount(getVillage?.data?.meta?.numberOfRecords);
        setVillages(getVillage?.data?.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getCatgory = async (facilityTypeId: any, urbanOrRuralId: any) => {
    try {
      if (facilityTypeId && urbanOrRuralId) {
        const facility_categoryResponse = await axios.getWithCache(`${endpoints.getFacilityCatByFacilityTypeIdRuralOrUrban(facilityTypeId, urbanOrRuralId)}`, Auth.loggedIn());
        const facility_category_options = facility_categoryResponse.data.data.map((key: any) => ({
          value: key.facility_category,
          label: key.facility_category,
          id: key.facility_category_id,
          code: key.facility_category_code,
        }));

        setFacilityDetailsFormData((create_facilitydetails: { facility_category: any; ownership: any; }) => ({
          ...create_facilitydetails,
          facility_category: {
            ...create_facilitydetails.facility_category,
            '#options': facility_category_options,
          }
        }));
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          facility_category: {
            ...facilityDetailsFormState.facility_category,
            value: [],
            id: [],
            code: []
          }
        }))
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getGramPanchayat = async (blockId: any) => {
    try {
      if (blockId) {
        const postData = {
          p_state_id: locationData.state?.state_id,
          p_dist_id: locationData.district?.district_id,
          p_sub_dist_ids: hierarchyDetailsRuralFormState?.sub_district?.id ? [hierarchyDetailsRuralFormState.sub_district?.id] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        const gramPanchayat = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        const gramPanchayatOptions = gramPanchayat?.data?.data.map((option1: any) => ({
          value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
          label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
          id: option1.gram_panchayat_id,
          code: option1.gram_panchayat_code
        }));
        setHierarchyDetailsRuralFormData((role_details: any) => ({
          ...role_details,
          gram_panchayat: {
            ...role_details.gram_panchayat,
            '#options': gramPanchayatOptions,
            '#required': gramPanchayatOptions?.length ? true : false,
          },

        }))
        setHierarchyDetailsRuralFormState((roleFormState: any) => ({
          ...roleFormState,
          gram_panchayat: {
            ...roleFormState.gram_panchayat,
            value: '',
            id: '',
            code: ''
          },
        }))
        const gramPanchayatCoveredOptions: any = [];
        gramPanchayat?.data?.data?.map((e: any) => {
          gramPanchayatCoveredOptions?.push(e.gram_panchayat_name)
        })
        setGramPanchayatCount(gramPanchayat?.data?.meta?.numberOfRecords);
        setGramPanchayats(gramPanchayat?.data?.data);
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }
  const getPacByState = async (stateId: any) => {
    if (stateId) {
      const getPAC = await axios.getWithCache(`${endpoints.getPacByStateId(stateId)}`, Auth.loggedIn());
      setHierarchyDetailsRuralFormData((hierarchy_details_rural: any) => ({
        ...hierarchy_details_rural,
        parlimentary: {
          ...hierarchy_details_rural.parlimentary,
          '#options': getPAC.data.data,
        },
        lac: {
          ...hierarchy_details_rural.lac,
          '#options': [],
        },
      }));
      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        lac: {
          ...hierarchyDetailsRuralFormState.lac,
          value: '',
          id: '',
        }
      }))
    }
  }

  const getWardList = async (ulbId: any, ulbCode: any, ulbName: any) => {
    try {
      if (ulbId) {
        const getWard = await axios.getWithCache(`${endpoints.getWard(ulbId)}`, Auth.loggedIn());

        for (let i = 0; i < getWard.data.data.length; i++) {
          getWard[i].ward_name = `${ulbName}-${getWard[i].ward_name}-${getWard.data.data[i].ward?.ward_code}`
        }

        setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: { ward: any; parlimentary: any; lac: any }) => ({
          ...hierarchy_details_urban,
          ward: {
            ...hierarchy_details_urban.ward,
            '#options': getWard.data.data
          },
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          ward: {
            ...hierarchyDetailsUrbanFormState.ward,
            value: '',
            id: '',
          },
        }))
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }

  }

  const getPAC = async (stateID: any) => {
    try {
      if (stateID) {
        const getPac = await axios.getWithCache(`${endpoints.getPacByStateId(stateID)}`, Auth.loggedIn());
        setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: { parlimentary: any; lac: any }) => ({
          ...hierarchy_details_urban,
          parlimentary: {
            ...hierarchy_details_urban.parlimentary,
            '#options': getPac.data.data,
          },
          lac: {
            ...hierarchy_details_urban.lac,
            '#options': [],
          },
        }))
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          lac: {
            ...hierarchyDetailsUrbanFormState.lac,
            value: '',
            id: '',
          }
        }))
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getLAC = async (pacID: any) => {
    try {
      if (pacID) {
        const getLac = await axios.getWithCache(`${endpoints.getLacByPac(pacID)}`, Auth.loggedIn());
        if (facilityDetailsFormState.rural_urban.value.toLowerCase() === ruralUrban.urban) {
          setHierarchyDetailsUrbanFormdata((hierarchy_details_urban: { lac: any }) => ({
            ...hierarchy_details_urban,
            lac: {
              ...hierarchy_details_urban.lac,
              '#options': getLac.data.data,
            }
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            lac: {
              ...hierarchyDetailsUrbanFormState.lac,
              value: '',
              id: '',
            }
          }));
        }
        else {
          setHierarchyDetailsRuralFormData((hierarchy_details_rural: { lac: any }) => ({
            ...hierarchy_details_rural,
            lac: {
              ...hierarchy_details_rural.lac,
              '#options': getLac.data.data,
            }
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            lac: {
              ...hierarchyDetailsRuralFormState.lac,
              value: '',
              id: '',
            }
          }))
        }
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const handleFacilityDetailsFormChange = (value: any, key: string, id: any, code: any) => {
    setFacilityDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    if(key==='hfr_id'){
      setHfrIdError(false);
    }
    setFacilityDetailsChange(true);
  };

  const handleEnrollmentDetailsFormChange = (value: string | boolean, key: string, id: any) => {
    setEnrollmentDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id
      },
    }));
    setEffectiveDateChange(true)
  };


  const handleHierarchyDetailsFormChange = (value: string | boolean, key: string, id: any, option?: any, code?: any) => {

    if (facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural) {
      setHierarchyDetailsRuralFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          code: code
        },
      }));
    } else {
      setHierarchyDetailsUrbanFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          code: code

        },
      }));

    }
    setHierarchyDetailsChange(true)
  };

  const handleInputChange = _.debounce((value: string, key: string) => {
    if (key === 'ulb') {
      setUlbInputText(value.trim());
    }
  }, 500);


  const handleLocationDetailsFormChange = (value: string | boolean, key: string, id: any) => {
    setLocationDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
      },
    }));
    
  };
  const handleLocationDetailsError = useCallback((value: any, key: string) => {
    setLocationDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        ...value
      },
    }));
  }, []);


  const abdmOnClick = () => {
    const fetchABDMLocal = async () => {
      try {
        const facilityId = hfrIdCheck;
        const response = await axios.get(`${endpoints.getABDMDetails(facilityId)}`, Auth.loggedIn());
        if (response.status === 200) {
          const facilities = response?.data.data;
          if (facilities.length > 0) {
            setABDMLocalData(facilities[0]);
            setABDMClickVerify(true);
          }
        }
        else {
          errorLogger(`Error fetching ABDM details:${response.status}`, "Health Facility Update")

        }
      }
      catch (error: any) {
        if (axios.isAxiosError(error)) {
          errorLogger(`Axios error:${error.message}`, "Health Facility Update")
          if (error.response) {
            errorLogger(`Error response:${error.response.status}`, "Health Facility Update")
            if (error.response.status === 500) {
              errorLogger(`error.response.data.data:${error.response.data.data}`, "Health Facility Update")
            }
          }
        } else {
          errorLogger(error, "Health Facility Update")
        }
      }
    }
    fetchABDMLocal();
  }
  const closeABDMLocalModal = () => {
    setABDMClickVerify(false);
  }

  const checkMatchingScore = () => {
    if (facilityDetailsFormState.hfr_id.value) {
      const enteredFCName = facilityDetailsFormState.facility_name.value;
      const ABDMFCName = abdmFacilityData.facilityName;
      const result = calculateSimilarity(enteredFCName, ABDMFCName)
      setMatchingScore(result);
      if (result < 70) {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          facility_name: {
            ...facilityDetailsFormState.facility_name,
            message: 'Matching score <70 %.',
            isError: true,
          },
        }));
      }
      else {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          hfr_id: {
            ...facilityDetailsFormState.hfr_id,
            message: '',
            isError: false,
            verifiedDetails: 'verified',
          },
        }));
      }
    }
  }

  useEffect(() => {
    if (facilityDetailsFormState.facility_name.value) {
      checkMatchingScore();

    }
  }, [abdmFacilityData])

  const showVerifyModal = async (facilityId: string) => {
    try {
      const response = await axios.post(`${endpoints.verifyHFR}`, { facilityId }, Auth.loggedInWithJSON());
      if (response.status === 200) {
        const facilities = response?.data.data?.facilities;
        if (facilities.length > 0) {
          const facility = facilities[0];
          if (facility.stateLGDCode === `${stateCode}` && facility.districtLGDCode === `${distCode}`) {
            setabdmFacilityData(facility);
            setClickVerify(true);
            setVerify(true);
            setHfrIdError(false);
          }
          else {
            setClickVerify(false);
            setVerify(false);
            setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
              ...facilityDetailsFormState,
              hfr_id: {
                ...facilityDetailsFormState.hfr_id,
                message: 'State code or District code is incorrect',
                isError: true,
              },
            }));
            setHfrIdError(true);
          }
        }
        else {
          setVerify(false);
          setClickVerify(false);
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            hfr_id: {
              ...facilityDetailsFormState.hfr_id,
              message: 'Enter Valid HFR Id',
              isError: true,
            },
          }));

        }
      }
      else {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          hfr_id: {
            ...facilityDetailsFormState.hfr_id,
            message: 'Enter Valid HFR Id',
            isError: true,
          },
        }));
        setClickVerify(false);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }


  const onClickVerify = async () => {
    try {
      if (facilityDetailsFormState?.hfr_id?.value) {
        const facilityId = facilityDetailsFormState?.hfr_id?.value;
        const facilityNameC = facilityDetailsFormState?.facility_name?.value;
        const ifHfrExistinRCH = await axios.get(`${endpoints.checkFacilityExistInFM(facilityId)}`, Auth.loggedIn());
        if (facilityDetailsFormState?.hfr_id?.value !== hfrIdCheck) {
          if (ifHfrExistinRCH.status === 200) {
            if (ifHfrExistinRCH?.data?.data?.[0]?.check_hfr_in_facility_master === true) {
              setVerify(false);
              setClickVerify(false);
              setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                ...facilityDetailsFormState,
                hfr_id: {
                  ...facilityDetailsFormState.hfr_id,
                  message: 'The HFR ID is already associted with another facility.',
                  isError: true,
                },
              }));
            } else {
              showVerifyModal(facilityId);
            }
          } else {
            errorLogger(`Error while checking HFR exist or not:${ifHfrExistinRCH.status}`, "Health Facility Update")
          }
        }
        else {
          showVerifyModal(facilityId);
        }
        if (facilityDetailsFormState.facility_name.value.length === 0) {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            facility_name: {
              ...facilityDetailsFormState.facility_name,
              message: 'Health Facility Name cannot be kept blank.',
              isError: true,
            },
          }));
        }
        if (facilityDetailsFormState.facility_name.value.length > 500) {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            facility_name: {
              ...facilityDetailsFormState.facility_name,
              message: 'Health Facility Name cannot more than 500 letters.',
              isError: true,
            },
          }));
        }
        if (facilityDetailsFormState?.hfr_id?.value === '000000000000') {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            hfr_id: {
              ...facilityDetailsFormState.hfr_id,
              message: 'Invalid HFR id.',
              isError: true,
            },
          }));
        }
        if (facilityDetailsFormState?.hfr_id?.value.length !== 12) {
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            hfr_id: {
              ...facilityDetailsFormState.hfr_id,
              message: 'HFR ID must be 12 digits',
              isError: true,
            },
          }));
        }
      }
    } catch (error: any) {
      setVerify(false);


      if (axios?.isAxiosError(error)) {
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          hfr_id: {
            ...facilityDetailsFormState.hfr_id,
            message: 'Enter Valid HFR Id',
            isError: true,
          },
        }));

        if (error.response) {
          errorLogger(error.response, "Health Facility Update");
          if (error.response.status === 500) {
            errorLogger(error.response.data.data, "Health Facility Update")
          }
        }
      }
    }
  }

  let FacilityDetailsFromABDM: any;
  const verifyHFRID = async (facilityId: string) => {
    try {
      const response = await axios.post(`${endpoints.verifyHFR}`, { facilityId }, Auth.loggedInWithJSON());

      if (response.status === 200) {

        const facilities = response?.data.data?.facilities;
        if (facilities.length > 0) {
          const facility = facilities[0];
          if (facility.stateLGDCode === `${stateCode}` && facility.districtLGDCode === `${distCode}`) {
            setHfrIdError(false);
            FacilityDetailsFromABDM = facility;
            return false;
          }
          else {
            setHfrIdError(true);
            return true;
          }

        }
        else {
          return false;
        }
      }
    }
    catch (error: any) {
      return false;
    }

  }
  const closeVerifyModal = () => {
    setClickVerify(false);
    setABDMdata(abdmFacilityData);
    setVerify(true);
  }

  useEffect(() => {
    if (verify === true) {
      setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
        ...enrollmentDetailsFormState,
        status: {
          ...enrollmentDetailsFormState.status,
          value: 'Functional',
          id: 'da1624e9-9ea0-4960-9634-c5a782850288'
        }
      }));
      setEnrollmentDetailsFormData((facility_enrollmentdetails: { status: any }) => ({
        ...facility_enrollmentdetails,
        status: {
          ...facility_enrollmentdetails.status,
          '#required': true,
          '#isDisabled': false
        }
      }));

    }
  }, [verify])

  useEffect(() => {
    if (!facilityDetailsFormState?.hfr_id?.value) {
      setEnrollmentDetailsFormData((facility_enrollmentdetails: { status: any }) => ({
        ...facility_enrollmentdetails,
        status: {
          ...facility_enrollmentdetails.status,
          '#isDisabled': true,
          '#required': false
        }
      }));
      setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
        ...enrollmentDetailsFormState,
        status: {
          ...enrollmentDetailsFormState.status,
          value: 'Inactive',
          id: 'd1b444b2-7735-4a35-8ba1-b8fbed0a0810',
        }
      }));
    }
    if (facilityDetailsFormState?.hfr_id?.value && facilityDetailsFormState?.hfr_id?.value === hfrIdCheck) {
      setVerify(true);
    }
  }, [facilityDetailsFormState?.hfr_id?.value])


  const onClickNext = (overwriteFacName: any = false) => {
    if (overwriteFacName) {
      setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
        ...facilityDetailsFormState,
        facility_name: {
          ...facilityDetailsFormState.facility_name,
          value: abdmFacilityData.facilityName,
          isError: false,
          message: ''
        },
        hfr_id: {
          ...facilityDetailsFormState.hfr_id,
          isError: false,
          message: '',
          verifiedDetails: 'verified',
        }
      }
      ))
    }
    closeVerifyModal()
  }

  const handleRuralFacilityUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedFacilitiesRural.filter((item: any) => !keys.includes(item.facility_id));
    setLinkedFacilitiesRural(filteredData);
  }
  const handleUrbanFacilityUnlink = (unlinkedUrbanfacilities: any) => {
    const keys = unlinkedUrbanfacilities.map((i: any) => i.id);
    const filteredData = unlinkedUrbanfacilities && unlinkedUrbanfacilities.length > 0 && linkedFacilitiesUrban.filter((item: any) => !keys.includes(item.facility_id));
    setLinkedFacilitiesUrban(filteredData);
  }


  const handleVillageUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedVillageRural.filter((item: any) => !keys.includes(item.village_id));
    setLinkedVillageRural(filteredData);
  }

  const handleGramPanchayatUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedGramPanchayatRural.filter((item: any) => !keys.includes(item.gram_panchayat_id));
    setLinkedGramPanchayatRural(filteredData);
  }

  const handleWardUnlink = (unlinkedruralfacilities: any) => {
    const keys = unlinkedruralfacilities.map((i: any) => i.id);
    const filteredData = unlinkedruralfacilities && unlinkedruralfacilities.length > 0 && linkedWardRural.filter((item: any) => !keys.includes(item.ward?.ward_id));
    setLinkedWardRural(filteredData);
  }

  const formatLinkedFacility = (data: any, type: string) => {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    if (type === 'linked-facility') {
      return data.map((item: any) => ({
        id: item.facility_id,
        name: item.facility_name,
        code: item.facility_code,
      }));
    } else if (type === 'village') {
      return data.map((item: any) => ({
        id: item.village_id,
        name: item.village_name,
        code: item.village_code,
      }));
    }
    else if (type === 'gram_panchayat') {
      return data.map((item: any) => ({
        id: item.gram_panchayat_id,
        name: item.gram_panchayat_name,
        code: item.gram_panchayat_code,
      }));
    }
    else if (type === 'ward') {
      return data.map((item: any) => ({
        id: item.ward_id,
        name: item.ward_name,
        code: item.ward_code,
      }));
    }
    else {
      return [];
    }
  }

  const [selectionLF, setSelectionLF] = useState<boolean>(false);
  const [selectionVillages, setSelectionVillages] = useState<boolean>(false);
  const [selectionGramPanchayats, setSelectionGramPanchayats] = useState<boolean>(false);
  const [selectionWards, setSelectionWards] = useState<boolean>(false);

  const getSelectionFacilitiesRural = async (blockId: any, facilityTypeId: any) => {
    try {
      if (blockId && facilityTypeId && id) {
        const data = {
          "blockId": blockId,
          "facilityTypeId": facilityTypeId,
          "facilityId": id
        }
        const getSelectionFacilitiesRuralData = await axios.post(`${endpoints.getLinkedFacilitiesByblockId}`, data, Auth.loggedInWithJSON());
        const linkedFaciltiesOptions: any = [];
        getSelectionFacilitiesRuralData.data.data.map((e: any) => {
          linkedFaciltiesOptions.push(e.facility_name)
        })
        setLinkedFacilitiesCount(getSelectionFacilitiesRuralData.data.meta.numberOfRecords);
        setLinkedFacilities(getSelectionFacilitiesRuralData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getSelectionFacilitiesUrban = async (ulbId: any, facilityTypeId: any) => {
    try {
      if (ulbId && facilityTypeId && id) {
        const data = {
          "ulbId": ulbId,
          "facilityTypeId": facilityTypeId,
          "facilityId": id
        }
        const getSelectionFacilitiesUrbanData = await axios.post(`${endpoints.getLinkedFacilitiesByUlbId}`, data, Auth.loggedInWithJSON());
        const linkedFaciltiesOptions: any = [];
        getSelectionFacilitiesUrbanData.data.data.map((e: any) => {
          linkedFaciltiesOptions.push(e.facility_name)
        })
        setLinkedFacilitiesCount(getSelectionFacilitiesUrbanData.data.meta.numberOfRecords);
        setLinkedFacilities(getSelectionFacilitiesUrbanData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getSelectionVillages = async (blockId: any, subDistrictId: any, healthBlockId: any, subDivisionId: any) => {
    try {
      let getSelectionVillagesData: any;
      if (blockId || healthBlockId || subDivisionId) {
        const params = {
          'blockId': blockId,
          'healthBlockId': healthBlockId,
          'subDivisionId': subDivisionId,
        };

        const postData = {
          p_state_id: locationData.state?.state_id,
          p_dist_id: locationData.district?.district_id,
          p_sub_dist_ids: subDistrictId ? [subDistrictId] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        if (!blockId && (healthBlockId || subDivisionId)) {
          setHBSDSelected(true);
          getSelectionVillagesData = await axios.post(`${endpoints.fetchVillageByBlockHBSD}`, params, Auth.loggedInWithJSON());
        }
        else {
          setHBSDSelected(false);
          getSelectionVillagesData = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        }
        const villagesCoveredOptions: any = [];
        getSelectionVillagesData.data.data.map((e: any) => {
          villagesCoveredOptions.push(e.village_name)
        })

        setVillagesCount(getSelectionVillagesData.data.meta.numberOfRecords);
        setVillages(getSelectionVillagesData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const getSelectionGramPanchayats = async (blockId: any, subDistrictId: any, healthBlockId: any, subDivisionId: any) => {
    try {
      if (blockId || healthBlockId || subDivisionId) {
        const params = {
          'blockId': blockId,
          'healthBlockId': healthBlockId,
          'subDivisionId': subDivisionId,
        };
        const postData = {
          p_state_id: locationData.state?.state_id,
          p_dist_id: locationData.district?.district_id,
          p_sub_dist_ids: subDistrictId ? [subDistrictId] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        let getSelectionGrampanchayatData: any;
        if (!blockId && (healthBlockId || subDivisionId)) {
          setHBSDSelected(true);
          getSelectionGrampanchayatData = await axios.post(`${endpoints.fetchGramPanchayatByBlockHBSD}`, params, Auth.loggedInWithJSON());
        }
        else {
          getSelectionGrampanchayatData = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
          setHBSDSelected(false);
        }

        const gramPanchayatCoveredOptions: any = [];
        getSelectionGrampanchayatData.data.data.map((e: any) => {
          gramPanchayatCoveredOptions.push(e.gram_panchayat_name)
        })

        setGramPanchayatCount(getSelectionGrampanchayatData.data.meta.numberOfRecords);
        setGramPanchayats(getSelectionGrampanchayatData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }

  const getSelectionWards = async (ulbId: any, healthBlockId: any, subDivisionId: any) => {
    try {
      if (!ulbId && (healthBlockId || subDivisionId)) {
        setHBSDSelected(true);
      }
      else {
        setHBSDSelected(false);
      }
      if (ulbId || healthBlockId || subDivisionId) {
        const params = {
          'ulbId': ulbId,
          'healthBlockId': healthBlockId,
          'subDivisionId': subDivisionId,
        };
        const getSelectionWardsData = await axios.post(`${endpoints.fetchWardByUlbHBSD}`, params, Auth.loggedIn());

        const wardsCoveredOptions: any = [];
        getSelectionWardsData.data.data.map((e: any) => {
          wardsCoveredOptions.push(e.ward?.ward_name)
        })

        setWardsCount(getSelectionWardsData.data.meta.numberOfRecords)
        setWards(getSelectionWardsData.data.data);
      }
    }
    catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error, "Health Facility Update")
    }
  }

  const onhandleSaveLFUrban = (selectedItems: any[], flag: boolean) => {
    setLinkedFacilitiesUrban(selectedItems);
    setSelectionLF(flag);
  }

  const onhandleSaveLFRural = (selectedItems: any[], flag: boolean) => {
    setLinkedFacilitiesRural(selectedItems);
    setSelectionLF(flag);
  }

  const onhandleOpenLFRural = () => {
    getSelectionFacilitiesRural(hierarchyDetailsRuralFormState.block.id, facilityDetailsFormState.facility_type.id);
    setSelectionLF(true);
  }

  const onhandleOpenLFUrban = () => {
    getSelectionFacilitiesUrban(hierarchyDetailsUrbanFormState.ulb.id, facilityDetailsFormState.facility_type.id);
    setSelectionLF(true);
  }

  const onhandleSaveVillages = (selectedItems: any[], flag: boolean) => {
    setLinkedVillageRural(selectedItems);
    setSelectionVillages(flag);
  }

  const onhandleOpenVillages = () => {
    setSelectionVillages(true);
  }

  const onhandleSaveGramPanchayats = (selectedItems: any[], flag: boolean) => {
    setLinkedGramPanchayatRural(selectedItems);
    setSelectionGramPanchayats(flag);
  }

  const onhandleOpenGramPanchayats = () => {
    setSelectionGramPanchayats(true);
  }

  const onhandleSaveWards = (selectedItems: any[], flag: boolean) => {
    setLinkedWardRural(selectedItems);
    setSelectionWards(flag);
  }

  const onhandleOpenWards = () => {
    const healthBlockId = facilityDetailsFormState?.rural_urban?.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormState?.health_block?.id : hierarchyDetailsUrbanFormState?.health_block?.id;
    const subDivisionId = facilityDetailsFormState?.rural_urban?.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormState?.sub_division?.id : hierarchyDetailsUrbanFormState?.sub_division?.id;
    if (!healthBlockId && !subDivisionId) {
      getSelectionWards(hierarchyDetailsUrbanFormState?.ulb?.id, '', '');
    }
    else {
      getSelectionWards('', healthBlockId, subDivisionId);
    }
    setSelectionWards(true);
  }

  const handleApprovalSubmit = async () => {
    setLoading(true);
    const isRural = facilityDetailsFormState.rural_urban.value?.toLowerCase() === ruralUrban.rural;
    const approveResubmitPayload = approvalSubmitPayload(healthFacilityData, abdmData, isRural, hierarchyDetailsRuralFormState, hierarchyDetailsUrbanFormState, facilityDetailsFormState, enrollmentDetailsFormState, locationDetailsFormState, linkedVillageRural, linkedWardRural, linkedFacilitiesUrban, linkedFacilitiesRural, locationData, linkedGramPanchayatRural)
    let statusChangedId = ''
    let status = ''
    if (approvalLayout.requestData.requestFor == 'sent') {
      const pendingData = approvalLayout.approvalStatus.length > 0 ? approvalLayout.approvalStatus.filter((ele: any) => ele.code == STATUS.PENDING) : [];
      statusChangedId = pendingData.length > 0 ? pendingData[0].id : ''
      status = 'PENDING'
    } else {
      const approveData = approvalLayout.approvalStatus.length > 0 ? approvalLayout.approvalStatus.filter((ele: any) => ele.code == STATUS.APPROVED) : [];
      statusChangedId = approveData.length > 0 ? approveData[0].id : ''
      status = 'APPROVED'
    }
    const reducerData = approvalLayout.requestData;
    const comments = approvalLayout.comments
    const res = await approvalStatusUpdate(reducerData, comments, approveResubmitPayload, statusChangedId, true,facilityDetailsFormState.facility_name.value,dayjs(enrollmentDetailsFormState.effective_from_date.value).format('YYYY-MM-DD'), status);
    if (res) {
      if (approvalLayout.requestData.requestFor == 'sent') {
        toast.success(errorSuccessMessage.reSubmit, {
          position: 'top-center',
        });
      } else {
        toast.success(errorSuccessMessage.approveSuccess, {
          position: 'top-center',
        });
      }
      clearMapStore()
      navigate(`/approvals-flow`)
      setLoading(false);
    }
  }

  const handleLocationDetailsDataChangeOnMapFails = useCallback((data: any) => {
    setlocationDetailsFormData((prevState: any) => ({
      ...prevState,
      lattitude: {
        '#type': 'textfield',
        '#title': 'Lattitude',
        '#webform_key': 'lattitude',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
      longitude: {
        '#type': 'textfield',
        '#title': 'Longitude',
        '#webform_key': 'longitude',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
      address: {
        '#type': 'textfield',
        '#title': 'Address',
        '#webform_key': 'address',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
    }));
  }, []);

  const handleSubmit = async () => {
    let hfrIdVerify: boolean = false;
    setLoading(true);
    if (facilityDetailsFormState?.hfr_id?.value === hfrIdCheck && hfrIdCheck?.length === 12 && !hfrIdError) {
      hfrIdVerify = await verifyHFRID(hfrIdCheck) ? true : false;
    }
    const isError: boolean[] = [];
    let similarityData: number;
    if (facilityDetailsFormState.facility_name.value) {
      const data = {
        stateCode: stateCode,
        distCode: distCode,
        facilityName: facilityDetailsFormState.facility_name.value,
      }
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data))
      const response = await axios.post(`${endpoints.checkSimilarity}`, { data: encodedPayload }, Auth.loggedIn());
      const data1 = response.data?.data[0];
      similarityData = data1?.similarity_percent;
    }
    {
      const FacilityDetailsFormStateError = {
        ...facilityDetailsFormState
      };
      let isFacilityFormError = false;
      Object.keys(FacilityDetailsFormStateError).map((item) => {
        if (item === 'facility_name') {
          if (!FacilityDetailsFormStateError.facility_name.value) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_name.isError = true;
            FacilityDetailsFormStateError.facility_name.message = 'Enter facility name to continue';
          }
          else if (!/^[a-zA-Z0-9\s.,\-@#$%&*!+?():'"/]+$/.test(facilityDetailsFormState.facility_name.value)) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_name.isError = true;
            FacilityDetailsFormStateError.facility_name.message = 'Health Facility Name cannot have special characters';
          }
          else if (facilityDetailsFormState.facility_name.value.length > 500) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_name.isError = true;
            FacilityDetailsFormStateError.facility_name.message = 'Health Facility Name length should be limited to 500';
          }
          else {
            FacilityDetailsFormStateError.facility_name.isError = false;
          }
        }
        else if (item === 'rural_urban') {
          if (!FacilityDetailsFormStateError.rural_urban.value) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.rural_urban.isError = true;
            FacilityDetailsFormStateError.rural_urban.message = 'Select an input to continue.';
          }
          else {
            FacilityDetailsFormStateError.rural_urban.isError = false;
          }
        }
        else if (item === 'facility_type') {
          if (!FacilityDetailsFormStateError.facility_type.value && facilityDetailsFormData.facility_type?.['#required']) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_type.isError = true;
            FacilityDetailsFormStateError.facility_type.message = 'Select facility type to continue.';
          } else {
            FacilityDetailsFormStateError.facility_type.isError = false;
          }
        }
        else if (item === 'ownership') {
          if (!FacilityDetailsFormStateError.ownership.value && facilityDetailsFormData.ownership?.['#required']) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.ownership.isError = true;
            FacilityDetailsFormStateError.ownership.message = 'Select ownership to continue.';
          } else {
            FacilityDetailsFormStateError.ownership.isError = false;
          }
        }
        else if (item === 'administrative_body') {
          if (!FacilityDetailsFormStateError.administrative_body.value && facilityDetailsFormData.administrative_body?.['#required']) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.administrative_body.isError = true;
            FacilityDetailsFormStateError.administrative_body.message = 'Select administrative body to continue.';
          } else {
            FacilityDetailsFormStateError.administrative_body.isError = false;
          }
        }
        else if (item === 'facility_category') {
          if ((!FacilityDetailsFormStateError.facility_category.value || FacilityDetailsFormStateError.facility_category.value.length === 0) && facilityDetailsFormData.facility_category?.['#required']) {
            isFacilityFormError = true;
            FacilityDetailsFormStateError.facility_category.isError = true;
            FacilityDetailsFormStateError.facility_category.message = 'Select facility category to continue.';
          } else {
            FacilityDetailsFormStateError.facility_category.isError = false;
          }
        }
      })
      setFacilityDetailsFormState(FacilityDetailsFormStateError);
      isError[0] = isFacilityFormError;
    }
    {
      const EnrollmentDetailsFormStateError = {
        ...enrollmentDetailsFormState
      };
      let isEnrollmentFormError = false;
      Object.keys(EnrollmentDetailsFormStateError).map((item) => {
        if (item === 'status') {
          if (!EnrollmentDetailsFormStateError.status.value) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.status.isError = true;
            EnrollmentDetailsFormStateError.status.message = 'Select state from the dropdown';
          }
          else {
            EnrollmentDetailsFormStateError.status.isError = false;
          }
        }
        else if (item === 'sanctionedbed_count') {
          if (!EnrollmentDetailsFormStateError.sanctionedbed_count.value) {
            EnrollmentDetailsFormStateError.sanctionedbed_count.isError = false;
            EnrollmentDetailsFormStateError.sanctionedbed_count.message = '';
          }
          else if (EnrollmentDetailsFormStateError.sanctionedbed_count.value.length > 4) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.sanctionedbed_count.isError = true;
            EnrollmentDetailsFormStateError.sanctionedbed_count.message = 'Sanctioned bed count should be limited to 4 digits';
          } else {
            EnrollmentDetailsFormStateError.sanctionedbed_count.isError = false;
          }
        }
        else if (item === 'functionalbed_count') {
          if (!EnrollmentDetailsFormStateError.functionalbed_count.value) {
            EnrollmentDetailsFormStateError.functionalbed_count.isError = false;
            EnrollmentDetailsFormStateError.functionalbed_count.message = '';
          }
          else if (EnrollmentDetailsFormStateError.functionalbed_count.value.length > 4) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.isError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.message = 'functional bed count should be limited to 4 digits';
          }
          else if (parseInt(EnrollmentDetailsFormStateError.functionalbed_count.value) > parseInt(EnrollmentDetailsFormStateError.sanctionedbed_count.value)) {
            isEnrollmentFormError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.isError = true;
            EnrollmentDetailsFormStateError.functionalbed_count.message = 'Functional bed count should be less than or equal to sanctioned bed count';
          } else {
            EnrollmentDetailsFormStateError.functionalbed_count.isError = false;
          }
        }
      })
      setEnrollmentDetailsFormState(EnrollmentDetailsFormStateError);
      isError[1] = isEnrollmentFormError;
    }
    {
      if (facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural) {
        const HierarchyDetailsRuralFormStateError = {
          ...hierarchyDetailsRuralFormState
        };
        let isHierarchyRuralFormError = false;
        Object.keys(HierarchyDetailsRuralFormStateError).map((item) => {
          if (item === 'state') {
            if (!HierarchyDetailsRuralFormStateError.state.value) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.state.isError = true;
              HierarchyDetailsRuralFormStateError.state.message = 'Select state from the dropdown';
            }
            else {
              HierarchyDetailsRuralFormStateError.state.isError = false;
            }
          }
          else if (item === 'district') {
            if (!HierarchyDetailsRuralFormStateError.district.value) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.district.isError = true;
              HierarchyDetailsRuralFormStateError.district.message = 'Select District from the dropdown';
            }
            else {
              HierarchyDetailsRuralFormStateError.district.isError = false;
            }
          }
          else if (item === 'sub_district') {
            if (!HierarchyDetailsRuralFormStateError.sub_district.value && hierarchyDetailsRuralFormData.sub_district?.['#required']) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.sub_district.isError = true;
              HierarchyDetailsRuralFormStateError.sub_district.message = 'Select sub district from the dropdown.';
            }
            else {
              HierarchyDetailsRuralFormStateError.sub_district.isError = false;
            }
          }
          else if (item === 'block') {
            if (!HierarchyDetailsRuralFormStateError.block.value && hierarchyDetailsRuralFormData.block?.['#required'] === true) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.block.isError = true;
              HierarchyDetailsRuralFormStateError.block.message = 'Select Block from the dropdown.';
            }
            else {
              HierarchyDetailsRuralFormStateError.block.isError = false;
            }
          }
          else if (item === 'village') {
            if (!HierarchyDetailsRuralFormStateError.village.value && hierarchyDetailsRuralFormData.village?.['#required'] === true && hierarchyDetailsRuralFormData.village?.['#isVisible'] === true) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.village.isError = true;
              HierarchyDetailsRuralFormStateError.village.message = 'Select Village from the dropdown';
            }
            else {
              hierarchyDetailsRuralFormState.village.isError = false;
            }
          }
          else if (item === 'gram_panchayat') {
            if (!HierarchyDetailsRuralFormStateError.gram_panchayat.value && hierarchyDetailsRuralFormData.gram_panchayat?.['#required'] === true && hierarchyDetailsRuralFormData.gram_panchayat?.['#isVisible'] === true) {
              isHierarchyRuralFormError = true;
              HierarchyDetailsRuralFormStateError.gram_panchayat.isError = true;
              HierarchyDetailsRuralFormStateError.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown';
            }
            else {
              hierarchyDetailsRuralFormState.gram_panchayat.isError = false;
            }
          }
        })
        setHierarchyDetailsRuralFormState(HierarchyDetailsRuralFormStateError);
        isError[2] = isHierarchyRuralFormError;
      }
      else {
        const HierarchyDetailsUrbanFormStateError = {
          ...hierarchyDetailsUrbanFormState
        };
        let isHierarchyUrbanFormError = false;
        Object.keys(HierarchyDetailsUrbanFormStateError).map((item) => {
          if (item === 'district') {
            if (!HierarchyDetailsUrbanFormStateError.district.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.district.isError = true;
              HierarchyDetailsUrbanFormStateError.district.message = 'Select District from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.district.isError = false;
            }
          }
          else if (item === 'sub_district') {
            if (!HierarchyDetailsUrbanFormStateError.sub_district.value && hierarchyDetailsUrbanFormdata.sub_district?.['#required']) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.sub_district.isError = true;
              HierarchyDetailsUrbanFormStateError.sub_district.message = 'Select sub district from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.sub_district.isError = false;
            }
          }
          else if (item === 'state') {
            if (!HierarchyDetailsUrbanFormStateError.state.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.state.isError = true;
              HierarchyDetailsUrbanFormStateError.state.message = 'Select state from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.state.isError = false;
            }
          }
          else if (item === 'ulb') {
            if (!HierarchyDetailsUrbanFormStateError.ulb.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.ulb.isError = true;
              HierarchyDetailsUrbanFormStateError.ulb.message = 'Select ULB from the dropdown.';
            }
            else {
              HierarchyDetailsUrbanFormStateError.ulb.isError = false;
            }
          }
          else if (item === 'ward') {
            if (!HierarchyDetailsUrbanFormStateError.ward.value) {
              isHierarchyUrbanFormError = true;
              HierarchyDetailsUrbanFormStateError.ward.isError = true;
              HierarchyDetailsUrbanFormStateError.ward.message = 'Select Ward from the dropdown.';
            }
            else {
              hierarchyDetailsUrbanFormState.ward.isError = false;
            }
          }
        })
        setHierarchyDetailsUrbanFormState(HierarchyDetailsUrbanFormStateError);
        isError[3] = isHierarchyUrbanFormError;
      }
    }
    {
      const LocationDetailsFormStateError = {
        ...locationDetailsFormState
      };
      let isLocationFormError = false;
      Object.keys(LocationDetailsFormStateError).map((item) => {
        if (item === 'address') {
          if (!LocationDetailsFormStateError.address.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.address.isError = true;
            LocationDetailsFormStateError.address.message = 'Enter address to continue.';
          }
          else {
            LocationDetailsFormStateError.address.isError = false;
          }
        }
        else if (item === 'pincode') {
          if (!LocationDetailsFormStateError.pincode.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.pincode.isError = true;
            LocationDetailsFormStateError.pincode.message = 'Enter valid pincode to continue.';
          }
          else if (!/^\d{6}$/.test(LocationDetailsFormStateError.pincode.value)) {
            isLocationFormError = true;
            LocationDetailsFormStateError.pincode.isError = true;
            LocationDetailsFormStateError.pincode.message = 'Enter valid pincode to continue.';
          }
          else if (LocationDetailsFormStateError.pincode.value.length !== 6) {
            isLocationFormError = true;
            LocationDetailsFormStateError.pincode.isError = true;
            LocationDetailsFormStateError.pincode.message = 'Pincode should be in 6 digits.';
          }
          else {
            LocationDetailsFormStateError.pincode.isError = false;
          }
        }
        else if (item === 'longitude') {
          if (!LocationDetailsFormStateError.longitude.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.longitude.isError = true;
            LocationDetailsFormStateError.longitude.message = 'Enter valid longitude to continue.';
          }
          else if (!/^-?\d{1,3}\.\d+$/.test(LocationDetailsFormStateError.longitude.value) ||
            parseFloat(LocationDetailsFormStateError.longitude.value) < -180 ||
            parseFloat(LocationDetailsFormStateError.longitude.value) > 180) {
            isLocationFormError = true;
            LocationDetailsFormStateError.longitude.isError = true;
            LocationDetailsFormStateError.longitude.message = 'Enter valid longitude to continue.';
          }
          else {
            LocationDetailsFormStateError.longitude.isError = false;
          }
        }
        else if (item === 'lattitude') {
          if (!LocationDetailsFormStateError.lattitude.value) {
            isLocationFormError = true;
            LocationDetailsFormStateError.lattitude.isError = true;
            LocationDetailsFormStateError.lattitude.message = 'Enter valid lattitude to continue.';
          }
          else if (!/^-?\d{1,3}\.\d+$/.test(LocationDetailsFormStateError.lattitude.value) ||
            parseFloat(LocationDetailsFormStateError.lattitude.value) < -90 ||
            parseFloat(LocationDetailsFormStateError.lattitude.value) > 90) {
            isLocationFormError = true;
            LocationDetailsFormStateError.lattitude.isError = true;
            LocationDetailsFormStateError.lattitude.message = 'Enter valid latitude to continue.'
          }
          else {
            LocationDetailsFormStateError.lattitude.isError = false;
          }
        }
      });

      setLocationDetailsFormState(LocationDetailsFormStateError);
      isError[4] = isLocationFormError;

      if (!isLocationFormError && enableArcGISMap !== 'OFF') {
        if (!facilityGeoMap?.mapServicesDown) {
          if (!geometryEngine?.contains(facilityGeoMap?.distFenceGeometry, facilityGeoMap?.mapPointer)) {
            toast.error("lattitude, longitude and address is not within district range", {
              position: "top-center",
            });

            return;
          }

          if (facilityGeoMap?.isManualLatLong) {
            toast.warning("lattitude, longitude is upadted manually, please locate it on map to proceed.", {
              position: "top-center",
            });

            return;
          }
        }
      }
    }
    {
      let isCoverageError = false;
      if (HBSDSelected) {
        let isCoverageRuralError = false;
        if (isGrampanchayat) {
          if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount > 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkGramPanchayat('Select Gram Panchayats / ADC Villages from the dropdown.');
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount === 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount > 0 && linkedWardRural.length === 0 && wardsCount === 0) {
            setIslinkedGramPanchayatRuralError(true);
            setErrorMessageCovLinkGramPanchayat('Select Gram Panchayats / ADC Villages from the dropdown.');
            isCoverageRuralError = true;
          }
          else {
            setIslinkedGramPanchayatRuralError(false);
            setIslinkedWardRuralError(false);
          }
          isCoverageError = isCoverageRuralError
        }
        else {
          if (linkedVillageRural.length === 0 && villagesCount > 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedVillageRuralError(true);
            setErrorMessageCovLinkVillages('Select villages from the dropdown.');
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedVillageRural.length === 0 && villagesCount === 0 && linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageRuralError = true;
          }
          else if (linkedVillageRural.length === 0 && villagesCount > 0 && linkedWardRural.length === 0 && wardsCount === 0) {
            setIslinkedVillageRuralError(true);
            setErrorMessageCovLinkVillages('Select villages from the dropdown.');
            isCoverageRuralError = true;
          }
          else {
            setIslinkedVillageRuralError(false);
            setIslinkedWardRuralError(false);
          }
          isCoverageError = isCoverageRuralError
        }

      }
      else {
        if (facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural) {
          let isCoverageRuralError = false;
          setIslinkedWardRuralError(false);
          if (isGrampanchayat) {
            if (linkedGramPanchayatRural.length === 0 && gramPanchayatCount > 0) {
              setIslinkedGramPanchayatRuralError(true);
              setErrorMessageCovLinkGramPanchayat('Select Gram Panchayats / ADC Villages from the dropdown.');
              isCoverageRuralError = true;
            }
            else {
              setIslinkedGramPanchayatRuralError(false);
            }
          } else {
            if (linkedVillageRural.length === 0 && villagesCount > 0) {
              setIslinkedVillageRuralError(true);
              setErrorMessageCovLinkVillages('Select villages from the dropdown.');
              isCoverageRuralError = true;
            }
            else {
              setIslinkedVillageRuralError(false);
            }
          }
          isCoverageError = isCoverageRuralError
        }
        else {
          let isCoverageUrbanError = false;
          setIslinkedGramPanchayatRuralError(false);
          setIslinkedVillageRuralError(false);
          if (linkedWardRural.length === 0 && wardsCount > 0) {
            setIslinkedWardRuralError(true);
            setErrorMessageCovLinkWard('Select wards from the dropdown.');
            isCoverageUrbanError = true;
          }
          else {
            setIslinkedWardRuralError(false);
          }
          isCoverageError = isCoverageUrbanError
        }
      }
      isError[5] = isCoverageError;
    }
    setLoading(false);
    if (!isError.includes(true) && !(approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent)) {
      setShowApprovalModal(true)
    }
    else if (!isError.includes(true) && (approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent)) {
      handleApprovalSubmit()
    }
  }


  return (
    <>
      {loading ? <div className='loader'>Loading...</div> :
        <div className='approval_update_facility_mangement'>
          <div className="cancel-edit">
            <Button
              onClick={() => { dispatch(setApprovalPageType(approvalConstantData.pageType.view)) }}
              disabled={false}
              id="cancel"
              buttonName={buttonNames.cancel}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            {(approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent) && <Button
              onClick={() => handleSubmit()}
              disabled={false}
              id="edit-details"
              buttonName={buttonNames.saveSubmit}
              colorType={'primary'}
            />}
            {approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received && <Button
              onClick={() => handleSubmit()}
              disabled={false}
              id="edit-details"
              buttonName={buttonNames.approve}
              colorType="primary"
            />}
          </div>
          <div className="update_facility">
            <BadgesComponent
              className="over-badge"
              badgeName="Facility Details"
              variant="primary-1"
              badgeType="case5"
            />
            <div className="approval-facility-details-update">
              <div className="update_approval_facility_details_page">
                <form className="update_approval_form_container_facility_details">
                  <HealthFormField
                    formData={facilityDetailsFormData}
                    formState={facilityDetailsFormState}
                    handleFormChange={(value: any, key: string, id: any, option: any, code: any) => {
                      if (key === 'facility_category') {
                        id = [];
                        option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                          if (value.includes(op.value)) {
                            id.push(op.id);
                          }
                        });
                        code = [];
                        option.length > 0 && value.length > 0 && option.forEach((op: any) => {
                          if (value.includes(op.value)) {
                            code.push(op.code);
                          }
                        });
                      }
                      if (key == 'hfr_id' || key == 'facility_name') {
                        setVerify(false);
                        setClickVerify(false);
                        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
                          ...facilityDetailsFormState,
                          hfr_id: {
                            ...facilityDetailsFormState.hfr_id,
                            verifiedDetails: 'not verified',
                          },
                        }));
                      }
                      handleFacilityDetailsFormChange(value, key, id, code);
                    }}
                    verified={verify}
                    onClickVerify={onClickVerify}
                  />
                </form>
                {verify && clickVerify &&
                  <HFRVerify closeVerifyModal={closeVerifyModal} onClickNext={onClickNext} facilityVerify={abdmFacilityData} matchingScore={matchingScore} action='update' />
                }

              </div>
              <hr></hr>
            </div>
          </div>
         <div className="update_ABDM">
            <BadgesComponent
              className="over-badge"
              badgeName="ABDM Facility Details"
              variant="primary-1"
              badgeType="case5"
            />
            <a onClick={abdmOnClick} className='abdm_link_verify'>ABDM details</a>
            {abdmClickVerify && <ABDMVerify closeVerifyModal={closeABDMLocalModal} facilityVerify={abdmLocalData} />}
            <hr></hr>
          </div>
          <div className="update_enrollment">
            <BadgesComponent
              className="over-badge"
              badgeName="Enrollment Details"
              variant="primary-1"
              badgeType="case5"
            />
            <div className="approval-facility-details-update">
              <div className="update_approval_enrolment_details_page">
                <form className="udate_approval_form_container_enrolment_details">
                  <HealthFormField
                    formData={enrollmentDetailsFormData}
                    formState={enrollmentDetailsFormState}
                    handleFormChange={handleEnrollmentDetailsFormChange}
                  />
                </form>
              </div>
            </div>
            <hr></hr>
          </div>
          <div className="update_hierarchy">
            <BadgesComponent
              className="over-badge"
              badgeName="Hierarchy Details"
              variant="primary-1"
              badgeType="case5"
            />
            <div className="approval-facility-details-update">
              <div className="update_approval_hierarchy_page">
                <form className="update_approval_hierarchy_page">
                  <HealthFormField
                    formData={facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormData : hierarchyDetailsUrbanFormdata}
                    formState={facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState}
                    handleFormChange={handleHierarchyDetailsFormChange}
                    onInputChange={handleInputChange}
                  />
                </form>
              </div>
            </div>
            <hr></hr>
          </div>
            {approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received && roleData == roleType.only_approver ? (
              <div className="overview">
              <BadgesComponent
               className="over-badge"
               badgeName="Location Details"
               variant="primary-1"
               badgeType="case5"
              />
                <div className="overview-details">
                  <div>
                    <label className="overview-details-label">Address</label>
                    <div className="overview-details-value">
                      {healthFacilityData?.address ? healthFacilityData?.address : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">Latitude</label>
                    <div className="overview-details-value">
                      {healthFacilityData?.latitude ? healthFacilityData?.latitude : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">Longitude</label>
                    <div className="overview-details-value">
                      {healthFacilityData?.longitude ? healthFacilityData?.longitude : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">Pincode</label>
                    <div className="overview-details-value">
                      {healthFacilityData?.pincode ? healthFacilityData?.pincode : '-'}
                    </div>
                  </div>
                </div>
                <div className="form-map-upgrade">
                  <FacilityESRIMap
                    selectedAddressValue={{ current: { value: healthFacilityData?.address } }}
                    latitude={healthFacilityData?.latitude}
                    longitude={healthFacilityData?.longitude}
                    dtCode={{ dtCode: locationData?.district?.district_code }}
                    onLocationChange={() => { }}
                    onPostalCodeChange={() => { }}
                    onformFieldChange={() => { }}
                    mapRender={false}
                    pageType={page_type.approval_view}
                  />
                </div>
                <div className="attributionNotes">
                  Powered By <img src={`${config.root ? config.root : ''}/assets/images/NicBharatMaps.png`} alt="NicBharatMaps" style={{ height: 40 }} />
                </div>
              </div>
            ) : (
              <div className="update_location">
              <BadgesComponent
               className="over-badge"
               badgeName="Location Details"
               variant="primary-1"
               badgeType="case5"
              />
              <div className="approval-facility-details-update">
                <LocationDetailsEdit formData={locationDetailsFormData} formState={locationDetailsFormState} handleLocationDetailsDataChangeOnMapFails={handleLocationDetailsDataChangeOnMapFails} handleFormChange={handleLocationDetailsFormChange} handleLocationDetailsError={handleLocationDetailsError} facilityFormState={facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState} />
              </div>
               <hr></hr>
               </div>
            )}
         
          {
            approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received && roleData == roleType.only_approver ? (
              <div className="overview">
                        <div className="upgrade_coverage">
                          <BadgesComponent
                            className="over-badge"
                            badgeName="Coverage Details"
                            variant="primary-1"
                            badgeType="case5"
                          />
                          <div className="overview-details-upgrade">
                            <div className="upgrade_coverage_details_page">
                              {locationData?.urban_rual?.urban_rural_name === ruralUrban.rural && (
                                <div className="coverage_rural_facility_village">
                                  <div className="coverage_rural_facility">
                                    <CoverageCardViewComponent
                                      listItems={formatLinkedFacility(
                                        locationData?.linked_facility_details,
                                        'linked-facility',
                                      )}
                                      labelforCoverage={'Linked Facilities'}
                                    />
                                  </div>
                                  <div className="coverage_urban_ward">
                                    <CoverageCardViewComponent
                                      listItems={formatLinkedFacility(
                                        locationData?.linked_ward,
                                        'ward',
                                      )}
                                      labelforCoverage={'Linked Wards'}
                                    />
                                  </div>
                                  <div className="coverage_rural_village">
                                    {isGrampanchayat ? (
                                      <CoverageCardViewComponent
                                        listItems={formatLinkedFacility(
                                          locationData?.linked_gram_panchayat,
                                          'gram_panchayat',
                                        )}
                                        labelforCoverage={
                                          'Linked Gram Panchayats / ADC Villages'
                                        }
                                      />
                                    ) : (
                                      <CoverageCardViewComponent
                                        listItems={formatLinkedFacility(
                                          locationData?.linked_village,
                                          'village',
                                        )}
                                        labelforCoverage={'Linked Villages'}
                                      />
                                    )}
                                  </div>
                                </div>
                              )}
                              {locationData?.urban_rual?.urban_rural_name !== ruralUrban.rural && (
                                <div className="coverage_urban_facility_ward">
                                  <div className="coverage_urban_facility">
                                    <CoverageCardViewComponent
                                      listItems={formatLinkedFacility(
                                        locationData?.linked_facility_details,
                                        'linked-facility',
                                      )}
                                      labelforCoverage={'Linked Facilities'}
                                    />
                                  </div>
                                  <div className="coverage_urban_ward">
                                    <CoverageCardViewComponent
                                      listItems={formatLinkedFacility(
                                        locationData?.linked_ward,
                                        'ward',
                                      )}
                                      labelforCoverage={'Linked Wards'}
                                    />
                                  </div>
                                  <div className="coverage_rural_village">
                                    {isGrampanchayat ? (
                                      <CoverageCardViewComponent
                                        listItems={formatLinkedFacility(
                                          locationData?.linked_gram_panchayat,
                                          'gram_panchayat',
                                        )}
                                        labelforCoverage={
                                          'Linked Gram Panchayats / ADC Villages'
                                        }
                                      />
                                    ) : (
                                      <CoverageCardViewComponent
                                        listItems={formatLinkedFacility(
                                          locationData?.linked_village,
                                          'village',
                                        )}
                                        labelforCoverage={'Linked Villages'}
                                      />
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
            ):(
                   <div className="update_coverage">
            <BadgesComponent
              className="over-badge"
              badgeName="Coverage Details"
              variant="primary-1"
              badgeType="case5"
            />
            <div className="approval-facility-details-update">
              <div className="update_coverage_details_page">
                {facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural && (
                  <div className='coverage_rural_facility_village'>
                    <div className='coverage_rural_facility'>
                      {
                        <CoverageCardComponent listItems={formatLinkedFacility(linkedFacilitiesRural, 'linked-facility')} required={false}
                          onUnlink={handleRuralFacilityUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenLFRural} linkButtonName={'Link'} labelforCoverage={'Linked Facilities'} inputType={islinkedFacilitiesRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkFacilities} linkButtonStatus={linkedFacilitiesCount} />
                      }
                    </div>
                    <div className='coverage_urban_ward'>
                      {
                        <CoverageCardComponent listItems={formatLinkedFacility(linkedWardRural, 'ward')} inputType={islinkedWardRuralError ? 'error' : ''} required={wardsCount > 0} errorMessage={errorMessageCovLinkWard}
                          onUnlink={handleWardUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenWards} linkButtonName={'Link'} labelforCoverage={'Linked Wards'} linkButtonStatus={wardsCount} />
                      }
                    </div>
                    <div className='coverage_rural_village'>
                      {
                        isGrampanchayat ?
                          <CoverageCardComponent listItems={formatLinkedFacility(linkedGramPanchayatRural, 'gram_panchayat')} required={gramPanchayatCount > 0} inputType={islinkedGramPanchayatRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkGramPanchayat}
                            onUnlink={handleGramPanchayatUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenGramPanchayats} linkButtonName={'Link'} labelforCoverage={'Linked Gram Panchayats / ADC Villages'} linkButtonStatus={gramPanchayatCount} />
                          :
                          <CoverageCardComponent listItems={formatLinkedFacility(linkedVillageRural, 'village')} required={villagesCount > 0} inputType={islinkedVillageRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkVillages}
                            onUnlink={handleVillageUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenVillages} linkButtonName={'Link'} labelforCoverage={'Linked Villages'} linkButtonStatus={villagesCount} />
                      }
                    </div>
                  </div>
                )}
                {facilityDetailsFormState.rural_urban.value !== ruralUrbanLabel.rural && (
                  <div className='coverage_urban_facility_ward'>
                    <div className='coverage_urban_facility'>
                      {
                        <CoverageCardComponent listItems={formatLinkedFacility(linkedFacilitiesUrban, 'linked-facility')} required={false}
                          onUnlink={handleUrbanFacilityUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenLFUrban} linkButtonName={'Link'} labelforCoverage={'Linked Facilities'} inputType={islinkedFacilitiesRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkFacilities} linkButtonStatus={linkedFacilitiesCount} />
                      }
                    </div>
                    <div className='coverage_urban_ward'>
                      {
                        <CoverageCardComponent listItems={formatLinkedFacility(linkedWardRural, 'ward')} inputType={islinkedWardRuralError ? 'error' : ''} required={wardsCount > 0} errorMessage={errorMessageCovLinkWard}
                          onUnlink={handleWardUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenWards} linkButtonName={'Link'} labelforCoverage={'Linked Wards'} linkButtonStatus={wardsCount} />
                      }
                    </div>
                    <div className='coverage_rural_village'>
                      {
                        isGrampanchayat ?
                          <CoverageCardComponent listItems={formatLinkedFacility(linkedGramPanchayatRural, 'gram_panchayat')} required={gramPanchayatCount > 0} inputType={islinkedGramPanchayatRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkGramPanchayat}
                            onUnlink={handleGramPanchayatUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenGramPanchayats} linkButtonName={'Link'} labelforCoverage={'Linked Gram Panchayats / ADC Villages'} linkButtonStatus={gramPanchayatCount} />
                          :
                          <CoverageCardComponent listItems={formatLinkedFacility(linkedVillageRural, 'village')} required={villagesCount > 0} inputType={islinkedVillageRuralError ? 'error' : ''} errorMessage={errorMessageCovLinkVillages}
                            onUnlink={handleVillageUnlink} unlinkButtonName={'Unlink'} onLink={onhandleOpenVillages} linkButtonName={'Link'} labelforCoverage={'Linked Villages'} linkButtonStatus={villagesCount} />
                      }
                    </div>
                  </div>
                )}

                {facilityDetailsFormState.rural_urban.value === ruralUrbanLabel.rural && selectionLF && (
                  <SelectionModal items={linkedFacilities} onSave={onhandleSaveLFRural} title='Linked Facilities Selected' searchPlaceholder='Search By Linked Facilities' selectedItemsProps={linkedFacilitiesRural} />
                )}
                {facilityDetailsFormState.rural_urban.value !== ruralUrbanLabel.rural && selectionLF && (
                  <SelectionModal items={linkedFacilities} onSave={onhandleSaveLFUrban} title='Linked Facilities Selected' searchPlaceholder='Search By Linked Facilities' selectedItemsProps={linkedFacilitiesUrban} />
                )}
                {selectionVillages && (
                  <SelectionModal items={villages} onSave={onhandleSaveVillages} title='Villages Selected' searchPlaceholder={'Search By Villages'} selectedItemsProps={linkedVillageRural} />
                )}
                {selectionGramPanchayats && (
                  <SelectionModal items={gramPanchayats} onSave={onhandleSaveGramPanchayats} title='Gram Panchayat / ADC Village Selected' searchPlaceholder={'Search By Gram Panchayat / ADC Village'} selectedItemsProps={linkedGramPanchayatRural} />
                )}
                {selectionWards && (
                  <SelectionModal items={wards} onSave={onhandleSaveWards} title='Wards Selected' searchPlaceholder={'Search By Wards'} selectedItemsProps={linkedWardRural} />

                )}
              </div>
            </div>
          </div>
            )
          }
         
          {showApprovalModal && <ApprovalModal showModal={showApprovalModal} handleModalClose={() => setShowApprovalModal(false)} handleSubmit={handleApprovalSubmit} headerText='Reason for Approval' isCommentsRequired={false} />}
        </div>}
    </>
  )
};
ApprovalHealthFacilityUpdate.displayName = 'ApprovalHealthFacilityUpdate';

export default ApprovalHealthFacilityUpdate;